var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInteractionDesign(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1123px",
    height: "915px",
    viewBox: "0 0 1123 915",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0042541%",
    y1: "100%",
    x2: "50.0042541%",
    y2: "-0.00539219211%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(0.994448, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1119.76555,465.74 C1119.76555,465.74 1119.76555,465.82 1119.76555,465.86 C1119.76151,465.879796 1119.76151,465.900204 1119.76555,465.92 C1119.76555,466.21 1119.68555,466.5 1119.63555,466.79 C1119.26555,469.15 1118.82555,471.52 1118.29555,473.89 C1114.68555,490.08 1107.29555,506.12 1097.40555,520.62 C1097.01555,521.18 1096.62555,521.74 1096.22555,522.29 C1095.46555,523.38 1094.69555,524.45 1093.90555,525.52 C1093.35555,526.25 1092.80555,526.98 1092.23555,527.71 C1088.35255,532.751274 1084.16472,537.550241 1079.69555,542.08 C1077.25555,544.54 1074.69555,546.92 1072.16555,549.19 L1071.04555,550.19 C1069.66555,551.39 1068.26555,552.556667 1066.84555,553.69 C1066.23555,554.18 1065.61555,554.69 1064.99555,555.14 L1063.91555,555.98 L1063.14555,556.55 C1062.45555,557.08 1061.75555,557.55 1061.04555,558.1 L1060.54555,558.45 C1058.87555,559.64 1057.19555,560.79 1055.48555,561.9 C1051.83862,564.262837 1048.07009,566.432492 1044.19555,568.4 C1042.40222,569.313333 1040.59889,570.17 1038.78555,570.97 C1036.58555,571.95 1034.36889,572.846667 1032.13555,573.66 C1031.53555,573.89 1030.92555,574.1 1030.31555,574.32 C1028.60555,574.91 1026.87555,575.46 1025.15555,575.96 L1024.27555,576.22 L1023.83555,576.34 L1023.83555,576.34 L1022.77555,576.63 C1017.63065,578.022404 1012.4083,579.110951 1007.13555,579.89 L1006.27555,580.02 L1005.82555,580.09 C999.135552,581.09 992.465552,581.59 985.825552,581.92 C976.682389,582.420229 967.518715,582.420229 958.375552,581.92 L955.875552,581.75 L955.425552,581.75 C953.695552,581.62 951.965552,581.46 950.245552,581.28 C949.245552,581.18 948.245552,581.07 947.245552,580.94 C945.725552,580.76 944.245552,580.55 942.705552,580.33 L942.635552,580.33 L941.185552,580.1 C939.875552,579.89 938.585552,579.67 937.295552,579.41 L935.975552,579.17 L933.975552,578.76 L933.585552,578.68 C929.398885,577.78 925.292219,576.686667 921.265552,575.4 L920.345552,575.09 C917.425552,574.116667 914.558885,573.033333 911.745552,571.84 C909.658885,570.94 907.608885,569.983333 905.595552,568.97 C902.715552,567.51 899.908885,565.94 897.175552,564.26 C893.355552,561.92 889.655552,559.4 886.075552,556.7 C881.365552,553.19 876.835552,549.41 872.435552,545.49 L871.525552,544.67 L869.865552,543.17 C847.257379,522.726198 828.278505,498.597703 813.735552,471.81 C812.215552,468.97 810.742219,466.083333 809.315552,463.15 C808.875552,462.25 808.445552,461.35 808.015552,460.44 C807.978101,460.368609 807.944715,460.295158 807.915552,460.22 L807.255552,458.82 C805.455552,454.94 803.755552,450.97 802.155552,446.95 L801.435552,445.13 L800.315552,442.19 L799.865552,440.96 C798.485552,437.226667 797.198885,433.443333 796.005552,429.61 C795.805552,428.95 795.595552,428.29 795.395552,427.61 C794.762219,425.53 794.158885,423.436667 793.585552,421.33 C793.055552,419.39 792.585552,417.42 792.075552,415.43 C791.995552,415.12 791.925552,414.81 791.855552,414.49 C787.855552,397.61 786.145552,379.37 790.205552,360.86 C790.475552,359.6 790.775552,358.34 791.115552,357.09 C791.595552,355.22 792.115552,353.35 792.775552,351.48 C792.915552,351.04 793.065552,350.6 793.215552,350.16 L793.395552,349.68 C793.395552,349.57 793.465552,349.45 793.505552,349.34 C793.539193,349.277401 793.562813,349.209915 793.575552,349.14 C793.925552,348.22 794.275552,347.3 794.655552,346.37 C795.035552,345.44 795.435552,344.52 795.845552,343.6 L795.845552,343.6 L795.905552,343.47 C795.905552,343.35 796.015552,343.24 796.065552,343.12 C796.395552,342.4 796.735552,341.68 797.065552,340.98 L797.425552,340.26 L797.525552,339.9 C797.715552,339.53 797.915552,339.15 798.115552,338.79 C800.854745,333.588963 804.096897,328.668797 807.795552,324.1 C809.850596,321.555244 812.054449,319.134344 814.395552,316.85 C817.926275,313.36273 821.810557,310.252623 825.985552,307.57 C826.652219,307.17 827.292219,306.78 827.905552,306.4 C833.23214,303.19328 839.131744,301.053527 845.275552,300.1 C853.215552,298.98 860.665552,300.27 867.915552,302 L868.645552,302.18 C869.865552,302.47 871.085552,302.78 872.295552,303.09 C876.525552,304.16 880.785552,305.27 885.085552,306.22 C889.085552,307.11 893.085552,307.87 897.215552,308.4 C901.375988,308.941547 905.570699,309.175515 909.765552,309.1 C910.385552,309.1 911.025552,309.1 911.655552,309.04 C919.381278,308.68008 926.989628,307.009625 934.155552,304.1 C939.643921,301.908744 944.626043,298.617957 948.795552,294.43 C949.593801,293.60342 950.348169,292.735563 951.055552,291.83 L951.055552,291.83 C952.276683,290.271457 953.341795,288.596752 954.235552,286.83 C954.515552,286.3 954.785552,285.76 955.045552,285.23 C955.045552,285.23 955.045552,285.23 955.045552,285.23 C955.145552,285.05 955.245552,284.85 955.345552,284.66 L955.345552,284.66 L956.875552,281.66 L956.875552,281.66 C956.935552,281.55 956.985552,281.44 957.045552,281.34 C957.785552,279.91 958.525552,278.5 959.285552,277.12 C962.244266,271.39456 965.876695,266.043273 970.105552,261.18 L970.105552,261.18 C974.544912,256.201362 980.028771,252.26432 986.165552,249.65 C987.165552,249.22 988.165552,248.81 989.275552,248.43 C993.928231,246.781099 998.819773,245.906162 1003.75555,245.84 C1004.34555,245.84 1004.91555,245.84 1005.48555,245.84 C1010.39051,245.985587 1015.24813,246.844598 1019.90555,248.39 L1019.90555,248.39 C1026.98553,250.798415 1033.66342,254.257028 1039.71555,258.65 C1048.91412,265.169293 1057.25038,272.826832 1064.52555,281.44 C1065.10555,282.12 1065.68555,282.82 1066.25555,283.52 C1072.47423,291.187915 1078.02452,299.374518 1082.84555,307.99 C1097.30555,333.61 1106.78555,363.62 1113.62555,394.18 L1113.95555,395.64 C1114.11555,396.36 1114.27555,397.08 1114.42555,397.79 C1114.74555,399.27 1115.06555,400.79 1115.36555,402.22 C1115.59555,403.31 1115.82555,404.41 1116.04555,405.5 L1116.04555,405.5 C1116.20555,406.29 1116.36555,407.07 1116.51555,407.87 C1116.61555,408.36 1116.71555,408.87 1116.80555,409.36 C1118.44743,417.540862 1119.65909,425.80221 1120.43555,434.11 C1120.43555,434.42 1120.43555,434.73 1120.50555,435.04 C1121.41873,445.268452 1121.17048,455.567424 1119.76555,465.74 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.87555,546.98 C1045.77555,546.69 1043.87555,547.98 1041.43555,550.09 C1040.25555,551.09 1038.94555,552.34 1037.52555,553.7 L1036.85555,554.35 L1036.55555,554.63 C1034.67555,556.44 1032.61555,558.44 1030.43555,560.46 C1029.07555,561.72 1027.67555,562.99 1026.22555,564.24 C1024.31555,565.89 1023.22555,570.42 1022.70555,576.62 C1017.56065,578.012404 1012.3383,579.100951 1007.06555,579.88 L1006.20555,580.01 L1005.75555,580.08 C1005.44555,578.22 1005.21555,577 1005.21555,577 C1005.21555,577 996.215552,569.49 998.835552,560.11 C1000.34555,554.73 1015.11555,544.66 1027.44555,537.04 C1028.95555,536.12 1030.44555,535.22 1031.83555,534.38 L1032.74555,533.83 C1033.31555,533.49 1033.85555,533.16 1034.39555,532.83 L1038.49555,530.43 C1041.33555,528.79 1043.39555,527.64 1044.12555,527.23 L1044.42555,527.06 C1044.42555,527.06 1049.68555,547.72 1046.87555,546.98 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.87555,546.98 C1045.77555,546.69 1043.87555,547.98 1041.43555,550.09 C1040.25555,551.09 1038.94555,552.34 1037.52555,553.7 L1036.85555,554.35 L1036.55555,554.63 C1034.67555,556.44 1032.61555,558.44 1030.43555,560.46 C1029.07555,561.72 1027.67555,562.99 1026.22555,564.24 C1024.31555,565.89 1023.22555,570.42 1022.70555,576.62 C1017.56065,578.012404 1012.3383,579.100951 1007.06555,579.88 L1006.20555,580.01 L1005.75555,580.08 C1005.44555,578.22 1005.21555,577 1005.21555,577 C1005.21555,577 996.215552,569.49 998.835552,560.11 C1000.34555,554.73 1015.11555,544.66 1027.44555,537.04 C1028.95555,536.12 1030.44555,535.22 1031.83555,534.38 L1032.74555,533.83 C1033.31555,533.49 1033.85555,533.16 1034.39555,532.83 L1038.49555,530.43 C1041.33555,528.79 1043.39555,527.64 1044.12555,527.23 L1044.42555,527.06 C1044.42555,527.06 1049.68555,547.72 1046.87555,546.98 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.71555,535.72 C1044.71555,535.72 1042.87555,537.61 1040.01555,540.6 C1038.81555,541.85 1037.42555,543.3 1035.92555,544.89 L1035.78555,545.04 L1035.00555,545.85 C1033.22555,547.73 1031.30555,549.76 1029.33555,551.85 C1019.11555,562.79 1007.55555,575.6 1007.55555,577.64 C1007.52106,578.402667 1007.3553,579.153672 1007.06555,579.86 L1006.20555,579.99 L1005.75555,580.06 C999.065552,581.06 992.395552,581.56 985.755552,581.89 C976.612389,582.390229 967.448715,582.390229 958.305552,581.89 L955.805552,581.72 L955.355552,581.72 C953.625552,581.59 951.895552,581.43 950.175552,581.25 C949.175552,581.15 948.175552,581.04 947.175552,580.91 C948.355552,579.27 949.585552,577.55 950.805552,575.79 C953.255552,572.27 955.685552,568.63 957.705552,565.33 C957.825552,565.14 957.935552,564.95 958.055552,564.77 C959.265552,562.77 960.315552,560.88 961.125552,559.25 C961.922797,557.811708 962.473738,556.250144 962.755552,554.63 C963.122241,552.655616 963.723153,550.732025 964.545552,548.9 C968.955552,537.7 980.485552,514.9 986.925552,502.31 L987.505552,501.19 L988.065552,500.11 C990.135552,496.11 991.465552,493.55 991.465552,493.55 L1007.21555,489.3 L1008.21555,489.03 L1011.69555,488.09 L1013.03555,487.73 L1020.48555,485.73 L1020.57555,485.73 L1020.84555,485.65 L1028.70555,483.54 L1031.31555,482.83 L1034.31555,482.04 L1041.91555,494.99 L1044.13555,527.33 L1044.71555,535.72 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.275552,579.32 C934.195552,575.32 932.405552,572.87 932.405552,572.87 C932.405552,572.87 936.775552,571.81 942.475552,570.2 C945.385552,569.37 948.645552,568.41 951.845552,567.36 C953.845552,566.69 955.845552,565.99 957.755552,565.28 C958.755552,564.92 959.665552,564.54 960.555552,564.17 C964.695552,562.43 967.805552,560.66 968.435552,559.08 C968.568918,558.447954 968.513272,557.790632 968.275552,557.19 C967.2991,554.30619 966.067561,551.515148 964.595552,548.85 C964.065552,547.85 963.485552,546.76 962.865552,545.63 C960.865552,541.98 958.475552,537.8 955.865552,533.39 C953.675552,529.71 951.325552,525.86 948.945552,522 C946.845552,518.61 944.715552,515.2 942.625552,511.9 C942.565552,511.8 942.495552,511.7 942.435552,511.59 C932.905552,496.53 924.345552,483.59 923.995552,483.1 L923.995552,483.1 L918.375552,496.59 L918.135552,496.81 L908.885552,505.02 L908.665552,505.23 C905.785552,507.78 902.515552,510.7 899.185552,513.68 C896.715552,515.89 894.185552,518.13 891.835552,520.29 C888.425552,523.35 885.235552,526.24 882.645552,528.61 C880.460019,530.48686 878.386458,532.490301 876.435552,534.61 C874.784246,538.087566 873.445635,541.705163 872.435552,545.42 C876.835552,549.34 881.365552,553.12 886.075552,556.64 C889.665552,559.32 893.355552,561.85 897.175552,564.19 C899.915552,565.87 902.722219,567.44 905.595552,568.9 C907.595552,569.906667 909.645552,570.863333 911.745552,571.77 C914.552219,572.97 917.418885,574.053333 920.345552,575.02 L921.265552,575.33 C925.265552,576.623333 929.372219,577.716667 933.585552,578.61 L933.975552,578.69 L935.975552,579.1 L937.275552,579.32 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.03555,484.49 L1013.13555,485.87 C1012.77555,486.44 1012.30555,487.17 1011.73555,488.04 C1011.16555,488.91 1010.37555,490.18 1009.52555,491.49 L1008.90555,492.49 C1007.44555,494.75 1005.74555,497.4 1003.90555,500.33 C1003.67555,500.68 1003.44555,501.03 1003.21555,501.4 C1002.98555,501.77 1002.74555,502.14 1002.50555,502.51 C990.505552,521.31 972.765552,549.17 968.305552,557.21 C967.939756,557.822281 967.605974,558.453129 967.305552,559.1 C966.735552,560.53 964.165552,562.1 960.615552,563.67 C959.825552,564.03 958.975552,564.38 958.105552,564.74 C956.165552,565.51 954.045552,566.26 951.885552,566.99 C948.735552,568.05 945.485552,568.99 942.525552,569.88 C936.265552,571.69 931.285552,572.88 931.285552,572.88 C931.285552,572.88 933.005552,575.21 935.955552,579.09 L933.955552,578.68 L933.565552,578.6 C929.378885,577.7 925.272219,576.606667 921.245552,575.32 L920.325552,575.01 C917.405552,574.036667 914.538885,572.953333 911.725552,571.76 C909.638885,570.86 907.588885,569.903333 905.575552,568.89 C902.695552,567.43 899.888885,565.86 897.155552,564.18 C893.335552,561.84 889.635552,559.32 886.055552,556.62 C881.345552,553.11 876.815552,549.33 872.415552,545.41 L871.505552,544.59 C872.49883,541.163225 873.759362,537.819638 875.275552,534.59 C875.275552,534.37 878.195552,531.59 882.495552,527.69 C885.145552,525.26 888.335552,522.38 891.685552,519.37 L899.035552,512.78 L907.725552,505.02 L907.945552,504.82 L916.945552,496.82 L917.185552,496.6 L922.815552,483.1 L923.955552,483.1 L944.425552,483.42 L944.525552,483.42 L946.525552,483.42 L947.645552,483.42 L954.065552,483.52 L961.705552,483.63 L970.595552,483.77 L1005.44555,484.31 L1006.57555,484.31 L1013.18555,484.41 L1014.03555,484.49 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.59555,345.17 L1011.21555,375.9 C1011.21555,375.9 976.595552,389.69 975.755552,389.41 C974.915552,389.13 952.675552,369.14 956.335552,355.91 C958.165552,349.28 959.015552,340.08 959.395552,332.57 C959.775552,325.06 959.715552,319.32 959.715552,319.32 C959.715552,319.32 1010.09555,301.32 1005.58555,313.69 C1003.95555,318.19 1004.68555,323.58 1006.29555,328.61 C1008.31368,334.474458 1011.10495,340.043557 1014.59555,345.17 Z",
    id: "Path",
    fill: "#FBBEBE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.29555,328.56 C1005.99555,328.92 1005.67555,329.26 1005.36555,329.56 C993.187718,342.482426 973.079641,343.758851 959.365552,332.48 C959.745552,325.03 959.685552,319.23 959.685552,319.23 C959.685552,319.23 1010.06555,301.23 1005.55555,313.6 C1003.95555,318.14 1004.68555,323.53 1006.29555,328.56 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.0041,254.540652 C1049.98202,291.811691 1019.75585,322.011036 982.48484,322 C945.213829,321.988958 915.005552,291.771714 915.005552,254.500668 C915.005552,217.229622 945.213815,187.012371 982.484826,187 C1000.42983,186.888644 1017.67221,193.968831 1030.35961,206.660004 C1043.04702,219.351176 1050.12209,236.595667 1050.0041,254.540652 Z",
    id: "Path",
    fill: "#FBBEBE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.935552,377.02 C972.935552,377.02 959.715552,347.7 955.205552,347.7 C950.695552,347.7 943.665552,499.35 943.665552,499.35 L1012.66555,500.44 L1015.48555,420.81 L1001.40555,350.23 C1001.40555,350.23 988.705552,378.1 972.935552,377.02 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.935552,379.27 C972.935552,379.27 959.715552,349.95 955.205552,349.95 C950.695552,349.95 943.665552,501.61 943.665552,501.61 L1021.91555,502.79 L1015.44555,423.06 L1001.36555,352.49 C1001.36555,352.49 988.705552,380.36 972.935552,379.27 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.935552,378.14 C972.935552,378.14 959.715552,348.83 955.205552,348.83 C950.695552,348.83 943.665552,500.48 943.665552,500.48 L1021.91555,501.66 L1015.44555,421.9 L1001.36555,351.32 C1001.36555,351.32 988.705552,379.23 972.935552,378.14 Z",
    id: "Path",
    fill: "#65617D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.105552,339.62 C960.105552,339.62 957.745552,336.16 954.365552,337.29 C950.985552,338.42 948.455552,335.29 945.075552,338.41 C941.695552,341.53 928.185552,345.73 925.655552,344.32 C923.125552,342.91 914.115552,349.11 912.145552,352.77 C910.175552,356.43 903.695552,366.28 903.695552,366.28 C903.695552,366.28 898.075552,373.03 898.915552,376.69 C899.755552,380.35 896.915552,384.57 893.565552,386.26 C890.215552,387.95 883.435552,404.84 883.435552,404.84 C883.435552,404.84 885.255552,427.42 877.655552,431.36 C870.055552,435.3 875.655552,452.47 875.655552,452.47 L911.555552,443.96 L921.715552,420.9 C921.715552,420.9 917.775552,488.45 912.985552,494.64 C908.195552,500.83 907.645552,504.78 907.645552,504.78 C907.645552,504.78 926.215552,508.72 930.155552,512.09 C934.095552,515.46 944.515552,511.25 944.515552,511.25 L954.645552,421.46 C954.645552,421.46 958.305552,404.58 958.305552,395.85 C958.305552,387.12 960.105552,339.62 960.105552,339.62 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.985552,339.62 C958.985552,339.62 956.615552,336.16 953.235552,337.29 C949.855552,338.42 947.325552,335.29 943.945552,338.41 C940.565552,341.53 927.065552,345.73 924.525552,344.32 C921.985552,342.91 912.985552,349.11 911.015552,352.77 C909.045552,356.43 902.575552,366.28 902.575552,366.28 C902.575552,366.28 896.945552,373.03 897.785552,376.69 C898.625552,380.35 895.785552,384.57 892.445552,386.26 C889.105552,387.95 882.305552,404.84 882.305552,404.84 C882.305552,404.84 884.125552,427.42 876.525552,431.36 C874.625552,432.36 873.525552,434.54 873.015552,437.28 C870.835552,448.28 879.875552,458.4 891.115552,458.05 L910.455552,450.05 L920.585552,420.9 C920.585552,420.9 916.645552,488.45 911.865552,494.64 C907.085552,500.83 906.525552,504.76 906.525552,504.76 C906.525552,504.76 925.105552,508.7 929.045552,512.07 C932.985552,515.44 943.395552,511.23 943.395552,511.23 L953.525552,421.44 C953.525552,421.44 957.185552,404.56 957.185552,395.83 C957.185552,387.1 958.985552,339.62 958.985552,339.62 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.945552,388.51 C896.945552,388.51 900.325552,397.8 909.615552,396.96 C918.905552,396.12 896.945552,388.51 896.945552,388.51 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.955552,374.44 C905.955552,374.44 912.145552,375.57 914.395552,380.91 C916.645552,386.25 905.955552,374.44 905.955552,374.44 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.405552,364.9 C923.405552,366.03 927.345552,385.73 923.405552,393.9 C919.465552,402.07 920.025552,411.63 920.025552,411.63 L923.405552,364.9 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.52555,332.84 C1006.52555,332.84 1008.73555,330.25 1010.98555,330.53 C1013.23555,330.81 1014.64555,332.22 1017.46555,333.35 C1020.28555,334.48 1027.02555,334.75 1027.02555,335.6 C1027.02555,336.45 1032.94555,339.82 1036.88555,340.66 C1040.82555,341.5 1053.20555,349.95 1056.30555,366.28 C1059.40555,382.61 1064.74555,387.39 1064.74555,387.39 L1034.91555,402.02 C1034.91555,402.02 1057.99555,499.97 1060.80555,507.02 C1063.61555,514.07 1063.90555,555.71 1063.90555,555.71 C1063.90555,555.71 1045.60555,563.87 1040.82555,566.41 C1036.04555,568.95 1038.00555,542.2 1028.15555,526.72 C1018.30555,511.24 1007.04555,488.72 1007.04555,488.72 L989.875552,440.59 C989.875552,440.59 978.875552,376.42 988.185552,364.59 C997.495552,352.76 1007.32555,337.07 1006.52555,332.84 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.96555,555.12 C1064.96555,555.5 1064.96555,555.7 1064.96555,555.7 L1063.87555,556.19 L1063.10555,556.53 L1055.46555,559.99 C1051.27555,561.9 1046.64555,563.99 1043.72555,565.47 C1042.99555,565.82 1042.37555,566.14 1041.89555,566.4 C1041.5479,566.621733 1041.10321,566.621733 1040.75555,566.4 C1039.25555,565.4 1038.57555,560.32 1037.51555,553.7 C1037.07555,550.96 1036.57555,547.96 1035.91555,544.89 C1035.81555,544.41 1035.70555,543.89 1035.59555,543.45 C1034.87115,540.179674 1033.91541,536.964922 1032.73555,533.83 C1031.80284,531.346886 1030.62713,528.961974 1029.22555,526.71 C1027.92555,524.71 1026.61555,522.53 1025.30555,520.33 C1021.78555,514.41 1018.30555,508.1 1015.38555,502.69 C1015.18555,502.3 1014.98555,501.93 1014.78555,501.56 C1014.04555,500.18 1013.34555,498.87 1012.71555,497.65 C1011.40555,495.15 1010.30555,493.03 1009.51555,491.49 L1008.24555,488.98 C1008.20765,488.890723 1008.16423,488.803889 1008.11555,488.72 L1006.56555,484.38 L1003.56555,476 L1000.07555,466.21 L998.425552,461.6 L997.235552,458.25 L996.855552,457.19 L990.935552,440.58 C990.935552,440.58 990.515552,438.17 989.935552,434.2 C988.365552,423.76 985.515552,402.53 985.525552,385.9 C985.485622,381.845521 985.719487,377.792971 986.225552,373.77 C986.295552,373.33 986.355552,372.9 986.435552,372.48 C986.515552,372.06 986.595552,371.56 986.685552,371.12 C987.054191,368.781532 987.931489,366.552443 989.255552,364.59 C998.535552,352.77 1008.43555,337.07 1007.59555,332.85 L1007.78555,332.64 C1008.19939,332.20333 1008.65488,331.808121 1009.14555,331.46 C1009.74262,331.024602 1010.4237,330.718114 1011.14555,330.56 C1011.44423,330.520119 1011.74688,330.520119 1012.04555,330.56 L1012.04555,330.56 C1014.29555,330.84 1015.70555,332.25 1018.51555,333.38 C1021.32555,334.51 1028.08555,334.78 1028.08555,335.63 C1028.08555,336.48 1033.99555,339.85 1037.93555,340.7 C1041.87555,341.55 1054.26555,349.98 1057.35555,366.31 C1060.35555,382.04 1065.41555,387.05 1065.78555,387.41 L1065.78555,387.41 L1064.67555,387.95 L1047.74555,396.26 L1044.11555,398.03 L1035.94555,402.03 C1035.94555,402.03 1038.08555,411.1 1041.13555,423.92 C1041.13555,424.09 1041.22555,424.27 1041.26555,424.45 C1041.35555,424.83 1041.44555,425.22 1041.54555,425.61 C1043.78555,435.01 1046.46555,446.21 1049.13555,457.26 L1049.37555,458.26 L1050.15555,461.46 C1050.39555,462.46 1050.64555,463.46 1050.88555,464.46 L1051.27555,466.05 C1052.01555,469.11 1052.75555,472.13 1053.47555,475.05 C1054.54555,479.38 1055.56555,483.49 1056.47555,487.25 C1059.07555,497.61 1061.08555,505.2 1061.80555,506.98 C1062.80555,509.56 1063.52555,516.81 1063.98555,524.98 C1064.77555,537.48 1064.94555,552.07 1064.96555,555.12 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.63555,456.06 C1067.80555,456.2 1066.74555,456.32 1065.51555,456.44 C1056.51555,457.26 1038.80555,457.44 1038.80555,457.44 C1038.80555,457.44 1025.57555,431.26 1014.31555,432.11 C1014.31555,432.11 1024.72555,420.29 1028.95555,421.7 C1029.65555,421.93 1030.09555,421.41 1030.31555,420.4 C1031.43555,415.4 1027.54555,398.05 1027.54555,398.05 L1022.19555,374.69 L1053.19555,382.29 C1056.01555,382.85 1064.73555,387.36 1064.73555,387.36 C1064.73555,387.36 1065.01555,399.46 1067.26555,402.27 C1069.51555,405.08 1072.05555,418.6 1071.77555,421.98 C1071.49555,425.36 1074.86555,441.12 1071.49555,445.34 C1068.12555,449.56 1075.67555,454.9 1068.63555,456.06 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.76555,456.06 C1068.92555,456.2 1067.87555,456.32 1066.64555,456.44 C1057.64555,457.26 1039.92555,457.44 1039.92555,457.44 C1039.92555,457.44 1026.69555,431.26 1015.44555,432.11 C1015.44555,432.11 1025.85555,420.29 1030.07555,421.7 C1030.78555,421.93 1031.22555,421.41 1031.43555,420.4 C1032.56555,415.4 1028.66555,398.05 1028.66555,398.05 L1023.32555,374.69 L1054.32555,382.29 C1057.13555,382.85 1065.86555,387.36 1065.86555,387.36 C1065.86555,387.36 1066.14555,399.46 1068.39555,402.27 C1070.64555,405.08 1073.17555,418.6 1072.89555,421.98 C1072.61555,425.36 1075.99555,441.12 1072.61555,445.34 C1069.23555,449.56 1076.79555,454.9 1069.76555,456.06 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.95555,394.7 C1037.95555,394.7 1063.85555,397.52 1064.95555,403.99 C1066.05555,410.46 1037.95555,394.7 1037.95555,394.7 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.00555,254.588792 C1041.03845,271.859275 1034.45196,288.479423 1022.61289,301 C1022.54024,300.904196 1022.48616,300.795525 1022.45347,300.679647 C1020.46078,296.394919 1018.46809,291.950015 1018.70721,287.244823 C1018.88655,281.578571 1022.13464,276.452916 1023.19077,270.84673 C1024.52587,263.75891 1022.21435,256.570979 1019.94268,249.743446 C1018.28875,244.737923 1015.08051,238.671229 1009.85966,239.291914 C1008.84698,239.529009 1007.8108,239.649914 1006.77099,239.652312 C1003.98122,239.211826 1003.42327,235.647894 1003.12436,232.764713 C1001.38483,219.24513 991.114858,208.423527 977.757403,206.035221 C976.278459,205.701092 974.734789,205.805422 973.313702,206.335552 C971.32101,207.216524 970.324664,209.318844 968.571096,210.540191 C962.871999,214.544609 955.618602,206.916193 948.644182,207.496833 C942.666108,207.997385 939.178898,214.044057 936.688033,219.510088 C934.197169,224.976119 931.228059,231.062835 925.469181,232.324227 C924.557545,232.613321 923.566974,232.504347 922.739194,232.023895 C920.945771,230.702437 922.18124,228.019477 923.117805,225.877113 C925.469181,220.531215 923.894955,216.266509 921.005552,212.44229 C938.839604,189.982399 968.855837,181.305037 995.842304,190.807811 C1022.82877,200.310585 1040.88728,225.916557 1040.86594,254.648858 L1041.00555,254.588792 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.575552,568.9 C902.695552,567.44 899.888885,565.87 897.155552,564.19 C893.335552,561.85 889.635552,559.33 886.055552,556.63 L882.605552,528.63 L882.495552,527.71 L875.945552,474.43 L875.555552,471.28 L886.435552,470.95 L894.135552,470.72 L894.655552,475.25 L899.035552,512.8 L899.145552,513.7 L905.575552,568.9 Z",
    id: "Path",
    fill: "#B2B1BB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.155552,564.17 C893.335552,561.83 889.635552,559.31 886.055552,556.61 L882.605552,528.61 L882.495552,527.69 L875.945552,474.41 L875.555552,471.26 L886.435552,470.93 L885.965552,472.67 L886.235552,474.86 L891.685552,519.37 L891.795552,520.29 L897.155552,564.17 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.095552,471.82 L971.505552,476.59 L970.595552,483.82 L968.595552,499.75 L968.455552,500.85 L968.315552,501.98 L962.855552,545.63 L961.165552,559.2 L960.605552,563.65 L960.545552,564.17 L958.345552,581.9 L955.845552,581.73 L955.395552,581.73 C953.665552,581.6 951.935552,581.44 950.215552,581.26 C949.215552,581.16 948.215552,581.05 947.215552,580.92 C945.695552,580.74 944.215552,580.53 942.675552,580.31 L942.605552,580.31 L941.155552,580.08 L942.525552,570.2 L942.525552,569.86 L948.925552,522 L951.635552,501.73 L951.785552,500.61 L951.935552,499.49 L954.065552,483.57 L954.965552,476.89 L955.485552,472.95 L956.135552,472.9 L972.095552,471.82 Z",
    id: "Path",
    fill: "#B2B1BB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.805552,474.36 L962.525552,476.75 L961.705552,483.68 L959.825552,499.61 L959.695552,500.72 L959.525552,501.9 L955.805552,533.44 L951.805552,567.02 L951.805552,567.41 L950.805552,575.79 L950.165552,581.25 C949.165552,581.15 948.165552,581.04 947.165552,580.91 C945.645552,580.73 944.165552,580.52 942.625552,580.3 L942.555552,580.3 L941.105552,580.07 L942.525552,570.2 L942.525552,569.86 L948.925552,522 L951.635552,501.73 L951.785552,500.61 L951.935552,499.49 L954.065552,483.57 L954.965552,476.89 L955.485552,472.95 L956.135552,472.9 L962.805552,474.36 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.73555,565.47 L1044.16555,568.38 C1042.37222,569.293333 1040.56889,570.15 1038.75555,570.95 C1036.55555,571.93 1034.33889,572.826667 1032.10555,573.64 L1030.43555,560.46 L1029.33555,551.87 L1027.44555,537.04 L1025.62555,522.72 L1025.31555,520.33 L1020.88555,485.57 L1020.10555,479.47 L1019.86555,477.47 L1019.63555,475.67 L1019.10555,471.51 L1019.37555,471.51 L1019.46555,471.51 L1027.07555,470.68 L1029.51555,470.43 L1030.27555,475.52 L1031.35555,482.76 L1038.49555,530.46 L1040.01555,540.61 L1041.43555,550.1 L1043.65555,564.96 L1043.73555,565.47 Z",
    id: "Path",
    fill: "#65617D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.73555,565.47 L1044.16555,568.38 C1042.37222,569.293333 1040.56889,570.15 1038.75555,570.95 C1036.55555,571.93 1034.33889,572.826667 1032.10555,573.64 L1030.43555,560.46 L1029.33555,551.87 L1027.44555,537.04 L1025.62555,522.72 L1025.31555,520.33 L1020.88555,485.57 L1020.10555,479.47 L1019.86555,477.47 L1019.63555,475.67 L1019.10555,471.51 L1019.37555,471.51 L1019.46555,471.51 L1027.07555,470.68 L1029.51555,470.43 L1030.27555,475.52 L1031.35555,482.76 L1038.49555,530.46 L1040.01555,540.61 L1041.43555,550.1 L1043.65555,564.96 L1043.73555,565.47 Z",
    id: "Path",
    fill: "#CCCCCC",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.16555,568.38 C1042.37222,569.293333 1040.56889,570.15 1038.75555,570.95 L1037.61555,561.01 L1036.85555,554.35 L1035.78555,545.04 L1035.60555,543.45 L1034.39555,532.85 L1028.74555,483.46 L1027.83555,475.55 L1027.54555,472.95 L1027.07555,470.67 L1029.51555,470.42 L1030.27555,475.51 L1031.35555,482.75 L1038.49555,530.45 L1040.01555,540.6 L1041.43555,550.09 L1043.65555,564.95 L1043.73555,565.47 L1044.16555,568.38 Z",
    id: "Path",
    fill: "#B2B1BB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.07555,470.98 L1068.01555,474.81 L1066.81555,553.67 C1066.20555,554.16 1065.58555,554.67 1064.96555,555.12 C1064.96555,555.5 1064.96555,555.7 1064.96555,555.7 L1063.87555,556.19 L1063.10555,556.53 C1062.41555,557.06 1061.71555,557.53 1061.00555,558.08 L1060.50555,558.43 C1058.83555,559.62 1057.15555,560.77 1055.44555,561.88 L1055.44555,559.99 L1055.44555,559.47 L1056.44555,491.47 L1056.50555,487.29 L1056.68555,475.03 L1056.76555,469.58 L1064.34555,470.53 L1068.07555,470.98 Z",
    id: "Path",
    fill: "#65617D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.07555,470.98 L1068.01555,474.81 L1066.81555,553.67 C1066.20555,554.16 1065.58555,554.67 1064.96555,555.12 C1064.96555,555.5 1064.96555,555.7 1064.96555,555.7 L1063.87555,556.19 L1063.10555,556.53 C1062.41555,557.06 1061.71555,557.53 1061.00555,558.08 L1060.50555,558.43 C1058.83555,559.62 1057.15555,560.77 1055.44555,561.88 L1055.44555,559.99 L1055.44555,559.47 L1056.44555,491.47 L1056.50555,487.29 L1056.68555,475.03 L1056.76555,469.58 L1064.34555,470.53 L1068.07555,470.98 Z",
    id: "Path",
    fill: "#CCCCCC",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.07555,470.98 L1068.01555,474.81 L1066.81555,553.67 C1066.20555,554.16 1065.58555,554.67 1064.96555,555.12 C1064.96555,555.5 1064.96555,555.7 1064.96555,555.7 L1063.87555,556.19 L1063.87555,555.96 L1064.05555,524.96 L1064.35555,474.85 L1064.35555,470.49 L1068.07555,470.98 Z",
    id: "Path",
    fill: "#B2B1BB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.74555,465.9 C1119.74151,465.919796 1119.74151,465.940204 1119.74555,465.96 C1119.74555,466.25 1119.66555,466.54 1119.61555,466.83 C1119.24555,469.19 1118.80555,471.56 1118.27555,473.93 L1068.02555,474.85 L1064.37555,474.92 L1056.74555,475.06 L1053.53555,475.12 L1052.41555,475.12 L1030.28555,475.53 L1027.84555,475.53 L1019.84555,475.68 L1019.67555,475.68 L1013.53555,475.8 L1003.62555,475.98 L1002.51555,475.98 L1002.51555,475.98 L971.515552,476.55 L962.515552,476.71 L954.955552,476.85 L948.365552,476.97 L947.235552,476.97 L944.865552,476.97 L944.755552,476.97 L939.755552,477.06 L916.985552,476.06 L915.865552,476.01 L894.685552,475.1 L886.265552,474.73 L875.975552,474.28 L813.745552,471.59 C812.225552,468.75 810.752219,465.863333 809.325552,462.93 C808.885552,462.03 808.455552,461.13 808.025552,460.22 L871.365552,459.22 L871.365552,459.22 L910.365552,458.62 L910.365552,458.62 L917.735552,458.51 L918.865552,458.51 L938.865552,458.2 L945.715552,458.58 L945.835552,458.58 L949.275552,458.77 L950.395552,458.83 L964.055552,459.59 L964.055552,459.59 L997.265552,461.42 L998.415552,461.48 L1013.93555,462.34 L1018.62555,462.6 L1018.72555,462.6 L1049.72555,464.31 L1050.86555,464.38 L1051.11555,464.38 L1119.74555,465.9 Z",
    id: "Path",
    fill: "#65617D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.74555,465.9 C1119.74906,465.919726 1119.74906,465.940274 1119.74555,465.96 C1119.74555,466.25 1119.66555,466.54 1119.61555,466.83 C1119.24555,469.19 1118.80555,471.56 1118.27555,473.93 L1068.02555,474.85 L1064.38555,474.92 L1056.74555,475.06 L1053.53555,475.12 L1052.41555,475.12 L1030.28555,475.53 L1027.84555,475.53 L1019.84555,475.68 L1019.67555,475.68 L1013.53555,475.8 L1003.62555,475.98 L1002.51555,475.98 L1002.51555,475.98 L971.515552,476.55 L962.515552,476.71 L954.955552,476.85 L948.365552,476.97 L947.235552,476.97 L944.865552,476.97 L944.755552,476.97 L939.755552,477.06 L916.975552,476.06 L915.855552,476.06 L894.685552,475.14 L886.255552,474.78 L875.965552,474.34 L813.735552,471.64 C812.215552,468.8 810.742219,465.913333 809.315552,462.98 C808.875552,462.08 808.445552,461.18 808.015552,460.27 L871.355552,459.27 L871.355552,459.27 L910.355552,458.67 L910.355552,458.67 L917.725552,458.56 L918.855552,458.56 L938.855552,458.25 L945.705552,458.63 L945.835552,458.63 L949.275552,458.82 L950.395552,458.89 L964.055552,459.64 L964.055552,459.64 L997.265552,461.47 L998.405552,461.53 L1013.92555,462.39 L1018.61555,462.65 L1018.71555,462.65 L1049.71555,464.36 L1050.85555,464.43 L1051.10555,464.43 L1119.74555,465.9 Z",
    id: "Path",
    fill: "#B2B1BB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.74555,465.9 C1119.74906,465.919726 1119.74906,465.940274 1119.74555,465.96 L1051.33555,466.13 L1050.21555,466.13 L1019.04555,466.21 L1013.84555,466.21 L1000.10555,466.21 L998.975552,466.21 L949.595552,466.33 L945.325552,466.33 L918.075552,466.4 L916.955552,466.4 L888.505552,466.47 L809.295552,463.05 C808.855552,462.15 808.425552,461.25 807.995552,460.34 L871.335552,459.34 L871.335552,459.34 L910.335552,458.74 L910.335552,458.74 L917.705552,458.63 L918.835552,458.63 L938.835552,458.32 L945.685552,458.7 L945.815552,458.7 L949.255552,458.89 L950.375552,458.96 L964.035552,459.71 L964.035552,459.71 L997.245552,461.54 L998.385552,461.6 L1013.90555,462.46 L1018.59555,462.72 L1018.69555,462.72 L1049.69555,464.43 L1050.83555,464.5 L1051.08555,464.5 L1119.74555,465.9 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.43555,420.04 C1055.12555,420.6 1064.97555,423.13 1066.94555,429.04 C1068.91555,434.95 1053.43555,420.04 1053.43555,420.04 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.38555,429.9 C1024.38555,429.9 1010.03555,434.26 1003.55555,434.26 C997.075552,434.26 971.755552,434.12 971.755552,434.12 C971.755552,434.12 905.605552,412.02 925.455552,442.28 C945.305552,472.54 976.675552,455.65 976.675552,455.65 C976.675552,455.65 979.215552,456.21 982.305552,456.92 C985.395552,457.63 1045.21555,457.06 1047.18555,454.67 C1049.15555,452.28 1024.38555,429.9 1024.38555,429.9 Z",
    id: "Path",
    fill: "#FBBEBE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.52555,456.44 C1056.52555,457.26 1038.81555,457.44 1038.81555,457.44 C1038.81555,457.44 1025.58555,431.26 1014.32555,432.11 C1014.32555,432.11 1024.73555,420.29 1028.96555,421.7 C1029.66555,421.93 1030.10555,421.41 1030.32555,420.4 C1041.32555,423.77 1062.32555,432.01 1064.42555,446.46 C1064.96555,450.37 1065.31555,453.65 1065.52555,456.44 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.64555,456.44 C1057.64555,457.26 1039.92555,457.44 1039.92555,457.44 C1039.92555,457.44 1026.69555,431.26 1015.44555,432.11 C1015.44555,432.11 1025.85555,420.29 1030.07555,421.7 C1030.78555,421.93 1031.22555,421.41 1031.43555,420.4 C1042.43555,423.77 1063.43555,432.01 1065.54555,446.46 C1066.09555,450.37 1066.44555,453.65 1066.64555,456.44 Z",
    id: "Path",
    fill: "#464353",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.52555,456.44 C1056.52555,457.27 1038.81555,457.44 1038.81555,457.44 C1038.81555,457.44 1025.58555,431.26 1014.32555,432.11 C1014.32555,432.11 1024.73555,420.29 1028.96555,421.69 C1029.66555,421.93 1030.10555,421.41 1030.32555,420.4 C1041.32555,423.77 1062.32555,432.01 1064.42555,446.46 C1064.96555,450.38 1065.31555,453.66 1065.52555,456.44 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.575552,531.78 C987.575552,531.78 1012.90555,525.58 1016.84555,528.96 C1020.78555,532.34 987.575552,531.78 987.575552,531.78 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.955552,555.98 C914.955552,555.98 925.655552,562.17 926.775552,567.24 C927.895552,572.31 914.955552,555.98 914.955552,555.98 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.685552,345.9 L869.685552,456.82 C869.685552,458.73 870.685552,459 872.375552,459.92 C878.005552,463.04 891.865552,468.6 908.505552,459.8 C910.215552,458.9 911.265552,458.6 911.265552,456.66 L911.265552,346.59 C911.265552,346.59 890.115552,355.12 869.685552,345.9 Z",
    id: "Path",
    fill: "#333F4F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#40868E",
    fill: "#2D394A",
    fillRule: "nonzero",
    cx: 890.475552,
    cy: 345.81,
    rx: 20.79,
    ry: 4.42
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 391.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 0.95,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.54,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 3.67,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4.34,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.48,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 4.14,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.54,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 3.01,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 3.21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 4.14,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.61,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 393.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 1.24,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.84,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 3.97,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4.64,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.77,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 4.44,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.84,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 3.31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 3.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 4.44,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.9,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 396.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 0.54,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.14,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 3.27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 3.94,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.07,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 3.73,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.14,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 2.6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 2.8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 3.73,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.2,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 398.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 0.84,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.43,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 3.56,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4.23,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.36,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 4.03,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.43,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 2.9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 3.09,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 4.03,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.49,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 400.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 1.13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.79,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.73,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 3.86,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4.53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.79,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.66,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 4.32,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.73,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 3.19,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.79,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 3.39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 4.32,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.79,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.79,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 402.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 1.43,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 2.09,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 3.02,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 4.15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4.82,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 5.09,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.95,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 4.62,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 3.02,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 3.49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 2.09,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 3.69,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 4.62,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 5.09,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 5.09,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 405.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 0.72,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.38,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.32,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 3.45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4.12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.38,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 3.91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.32,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 2.78,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.38,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 2.98,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 3.91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.38,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.38,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 407.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 1.02,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.68,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 3.74,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4.41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.68,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.55,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 4.21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 3.08,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.68,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 3.28,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 4.21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.68,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.68,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 409.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 1.31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.98,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 4.04,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4.71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.97,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.84,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 4.51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 3.38,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.98,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 3.57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 4.51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.97,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.97,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 412.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 0.61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 3.33,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.14,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 3.8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 2.67,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 2.87,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 3.8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.27,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 414.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 0.9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 3.63,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4.3,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.56,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.43,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 4.1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 2.97,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 3.16,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 4.1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.56,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.56,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 416.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 1.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.86,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 3.93,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4.6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.86,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.73,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 4.39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 3.26,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.86,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 3.46,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 4.39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.86,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.86,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 419.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 0.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.16,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.09,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 3.22,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 3.89,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.02,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 3.69,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.09,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 2.56,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.16,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 2.75,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 3.69,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.15,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 421.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 0.79,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 3.52,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4.19,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.32,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 3.98,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 2.85,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 3.05,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 3.98,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.45,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 423.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 1.09,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.75,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.68,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 3.81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4.48,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.75,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 4.28,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.68,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 3.15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.75,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 3.35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 4.28,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.75,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.75,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 425.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 1.38,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 2.04,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.98,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 4.11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4.78,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 5.04,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.91,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 4.57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.98,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 3.44,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 2.04,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 3.64,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 4.57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 5.04,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 5.04,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 428.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 0.68,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.34,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 3.4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4.07,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.34,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 3.87,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 2.74,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.34,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 2.94,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 3.87,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.34,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.34,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 430.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 0.97,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.64,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 3.7,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4.37,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.63,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 4.17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 3.04,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.64,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 3.23,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 4.17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.63,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.63,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 432.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 1.27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.93,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.86,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 3.99,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4.66,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.93,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 4.46,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.86,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 3.33,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.93,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 3.53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 4.46,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.93,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.93,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 435.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 0.56,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.23,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.16,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 3.29,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 3.96,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.22,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.09,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 3.76,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.16,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 2.63,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.23,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 2.82,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 3.76,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.22,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.22,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 437.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 0.86,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.52,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.46,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 3.59,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4.26,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.52,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 4.05,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.46,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 2.92,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.52,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 3.12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 4.05,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.52,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.52,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 439.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 1.16,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.82,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.75,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 3.88,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4.55,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.68,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 4.35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.75,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 3.22,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.82,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 3.41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 4.35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.81,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 441.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 1.45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 2.11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 3.05,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 4.18,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4.85,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 5.11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.98,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 4.64,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 3.05,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 3.51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 2.11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 3.71,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 4.64,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 5.11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 5.11,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    transform: "translate(871.005552, 444.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.57,
    cy: 0.75,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.94,
    cy: 1.41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.86,
    cy: 2.34,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.11,
    cy: 3.47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.64,
    cy: 4.14,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.37,
    cy: 4.4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.59,
    cy: 3.27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27.87,
    cy: 3.94,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35.68,
    cy: 2.34,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 33.23,
    cy: 2.81,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 38.37,
    cy: 1.41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.54,
    cy: 3.01,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.96,
    cy: 3.94,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.83,
    cy: 4.4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.17,
    cy: 4.4,
    r: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M894.776463,219.490716 C894.776463,219.490716 922.187111,209.22396 931.297297,230.379092 L933.860162,231.040817 L939.606587,232.524684 C954.122818,210.808088 992.345555,232.524684 992.345555,232.524684 L1046.00555,256.28661 L1044.00331,259.635337 L990.223182,240.846371 C990.223182,240.846371 983.115234,262.903855 973.784802,268.217703 C964.45437,273.531552 949.297423,265.270021 949.297423,265.270021 C939.846856,261.480145 939.12605,244.856823 939.286229,236.835919 L931.15714,235.211686 C930.596513,243.23259 927.6332,258.692881 913.136992,260.437427 C893.41494,262.803594 892.033396,245.378181 892.033396,245.378181 C892.033396,245.378181 891.532836,223.200384 894.776463,219.490716 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.615568,222.468555 C917.713068,224.471966 916.449567,227.296775 918.274623,228.598992 C919.097807,229.085492 920.088444,229.201912 921.00218,228.919538 C926.798237,227.657389 929.866738,221.486884 932.29346,216.077675 C934.720183,210.668466 938.310129,204.618166 944.326797,204.057211 C951.286077,203.476222 958.566245,211.049114 964.382358,207.082361 C966.147247,205.880315 967.210192,203.756699 969.175637,202.875199 C970.600781,202.350789 972.148167,202.253311 973.627971,202.594721 C987.068523,204.976186 997.405929,215.797355 999.1587,229.32022 C999.459534,232.124995 1000.04115,235.771202 1002.82887,236.211953 C1003.87647,236.229525 1004.92179,236.108264 1005.93748,235.851339 C1011.19204,235.250316 1014.40093,241.300616 1016.08559,246.309143 C1018.37193,253.140773 1020.67832,260.333018 1019.35465,267.445126 C1018.31176,273.034642 1015.02265,278.163373 1014.84215,283.85306 C1014.6817,288.541041 1016.66721,293.008647 1018.61259,297.275911 C1020.55798,301.543176 1023.72676,306.551703 1028.37965,305.95068 C1032.19021,305.449827 1034.29604,301.402937 1036.14115,297.937037 C1037.98627,294.471136 1041.27538,290.905065 1044.98566,291.926805 C1046.63021,292.407623 1048.35499,293.810011 1049.85916,292.948544 C1050.65627,292.36966 1051.17302,291.482673 1051.2831,290.504383 C1053.0881,282.610945 1050.50094,273.75587 1054.33155,266.643762 C1057.27972,261.17445 1063.27633,258.209402 1068.14983,254.322786 C1076.52614,247.641125 1081.82513,237.846419 1082.83107,227.185867 C1083.837,216.525315 1080.46352,205.914021 1073.48461,197.786535 C1068.29022,191.776303 1060.78944,186.306992 1060.36827,178.313383 C1060.04738,172.303151 1064.17883,166.613465 1064.21894,160.523096 C1064.25905,154.432728 1060.44849,149.283962 1056.19672,145.237072 C1043.43807,133.577911 1025.75824,128.926755 1008.9057,132.795892 C1004.53359,133.837665 1000.14142,135.480462 995.669033,134.919507 C990.494698,134.278416 986.162697,130.912686 981.509807,128.468525 C966.227469,120.755393 945.550186,126.364943 936.304573,140.749432 C930.949738,149.063587 928.86396,159.922073 920.881846,165.751998 C915.627289,169.578513 908.12651,171.000934 905.218453,176.810825 C903.473619,180.29676 903.975008,184.423786 904.496453,188.290369 C905.322964,194.602312 908.364675,200.416556 913.080233,204.698302 C917.652901,209.867102 921.824458,215.116038 918.615568,222.468555 Z",
    id: "Path",
    fill: "#464353",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.1,
    transform: "translate(904.005552, 162.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.66,4.84 C159.186093,3.31507555 159.587413,1.74992608 159.86,0.16 C159.324555,1.68210184 158.92303,3.24804815 158.66,4.84 L158.66,4.84 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.12,54.72 C16.3970754,53.6866566 16.7721079,52.6821052 17.24,51.72 C20.48,44.38 16.32,39.14 11.48,34.2 C6.77750554,29.9255432 3.74422131,24.1211979 2.92,17.82 C2.65015706,16.0918538 2.48983732,14.3483766 2.44,12.6 C2.04088756,13.1156809 1.6862806,13.6643181 1.38,14.24 C-0.36,17.72 0.14,21.84 0.66,25.7 C1.48422131,32.0011979 4.51750554,37.8055432 9.22,42.08 C12.92,45.8 16.22,49.8 16.12,54.72 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.04,121.28 C139.34,120.2 136.06,123.84 134.24,127.28 C132.42,130.72 130.24,134.7 126.48,135.28 C121.86,135.88 118.68,130.88 116.74,126.62 C114.8,122.36 112.74,117.9 112.98,113.22 C112.98,112.66 112.98,112.1 113.14,111.56 C111.834713,114.591104 111.024406,117.812071 110.74,121.1 C110.58,125.78 112.56,130.24 114.5,134.5 C116.44,138.76 119.6,143.76 124.24,143.16 C128.04,142.66 130.14,138.62 131.98,135.16 C133.82,131.7 137.1,128.14 140.8,129.16 C142.44,129.64 144.16,131.04 145.66,130.18 C146.454908,129.602101 146.970226,128.716625 147.08,127.74 C147.460694,125.976809 147.681589,124.182875 147.74,122.38 C146.34,123.02 144.7,121.8 143.04,121.28 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.2,83.8 C161.36,87.68 155.38,90.64 152.42,96.1 C151.251182,98.4809621 150.571138,101.07193 150.42,103.72 C153.42,98.42 159.26,95.5 164.04,91.72 C171.498992,85.6823529 176.538812,77.164348 178.24,67.72 C175.659813,74.0168926 171.515803,79.5514168 166.2,83.8 L166.2,83.8 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.42,103.64 C116.316948,101.387325 117.032557,99.0666144 117.56,96.7 C118.88,89.62 116.56,82.42 114.28,75.6 C112.62,70.6 109.4,64.56 104.28,65.16 C103.260515,65.4175487 102.211349,65.5386064 101.16,65.52 C98.38,65.08 97.8,61.52 97.52,58.64 C95.7659996,45.1430623 85.4601297,34.3433525 72.06,31.96 C70.5776506,31.618687 69.0280231,31.715973 67.6,32.24 C65.6,33.12 64.58,35.24 62.84,36.44 C57.1,40.44 49.84,32.84 42.84,33.42 C36.96,33.9 33.34,39.94 30.84,45.42 C28.34,50.9 25.36,56.98 19.58,58.24 C18.6687952,58.5218938 17.680903,58.4056712 16.86,57.92 C16.3158029,57.5297838 15.9833652,56.9092333 15.96,56.24 C15.7829378,57.4288117 15.4395757,58.5868173 14.94,59.68 C14.04,61.68 12.78,64.5 14.6,65.8 C15.420903,66.2856712 16.4087952,66.4018938 17.32,66.12 C23.1,64.86 26.16,58.7 28.58,53.3 C31,47.9 34.58,41.86 40.58,41.3 C47.52,40.72 54.78,48.28 60.58,44.32 C62.34,43.12 63.4,41 65.36,40.12 C66.7811963,39.5964833 68.3242954,39.4991707 69.8,39.84 C83.2033168,42.2174101 93.5120846,53.0201566 95.26,66.52 C95.56,69.32 96.14,72.96 98.92,73.4 C99.9647029,73.4175425 101.00712,73.2964876 102.02,73.04 C107.26,72.44 110.46,78.48 112.14,83.48 C114.22,90 116.38,96.86 115.42,103.64 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.0355521268,269.81 C0.0355521268,270.74 0.0355521268,271.67 0.105552127,272.61 C0.486168731,282.806248 1.66308551,292.957155 3.62555213,302.97 C9.35555213,332.77 21.3255521,362.57 35.4855521,390.97 C35.7155521,391.42 35.9455521,391.87 36.1655521,392.32 C36.5055521,392.99 36.8355521,393.66 37.1655521,394.32 C37.8322188,395.693333 38.5255521,397.053333 39.2455521,398.4 L40.8155521,401.4 L40.8155521,401.4 C41.1855521,402.12 41.5755521,402.84 41.9555521,403.57 C42.1855521,404.01 42.4255521,404.46 42.6755521,404.91 C46.5886578,412.375687 50.8774884,419.63833 55.5255521,426.67 L56.0555521,427.45 C61.8840992,436.21583 68.7171127,444.270462 76.4155521,451.45 C89.9555521,463.9 107.155552,472.9 125.525552,478.04 C126.145552,478.22 126.765552,478.38 127.395552,478.55 C128.595552,478.86 129.815552,479.16 131.035552,479.45 C131.875552,479.65 132.715552,479.84 133.565552,480.01 C139.424114,481.266629 145.361017,482.125258 151.335552,482.58 C154.575552,482.83 157.825552,482.95 161.055552,482.95 L162.455552,482.95 C166.448136,482.91817 170.436558,482.684538 174.405552,482.25 L174.975552,482.18 C185.736631,481.027748 196.250767,478.196759 206.135552,473.79 C207.715552,473.083333 209.265552,472.333333 210.785552,471.54 L211.565552,471.14 L211.945552,470.93 L211.945552,470.93 C217.036159,468.212159 221.934324,465.1483 226.605552,461.76 C232.055552,457.85 237.195552,453.61 242.165552,449.25 C249.583621,442.794492 256.596907,435.888075 263.165552,428.57 L263.465552,428.24 C266.285552,425.06 268.975552,421.793333 271.535552,418.44 L271.535552,418.38 C273.315552,416.04 275.022219,413.656667 276.655552,411.23 C276.735552,411.13 276.805552,411.02 276.885552,410.9 C279.275552,407.33 281.495552,403.67 283.515552,399.9 L283.975552,399.03 C285.435552,396.27 286.768885,393.463333 287.975552,390.61 C294.895552,374.53 297.975552,357.12 299.665552,339.67 C303.115552,304.41 301.105552,268.08 291.775552,232.81 C290.515552,228.036667 289.118885,223.286667 287.585552,218.56 C287.375552,217.93 287.175552,217.29 286.955552,216.66 C286.625552,215.66 286.275552,214.66 285.955552,213.61 C285.815552,213.19 285.665552,212.76 285.515552,212.34 C284.182219,208.5 282.738885,204.683333 281.185552,200.89 L280.375552,198.89 C279.525552,196.89 278.655552,194.8 277.745552,192.77 C276.915552,190.9 276.055552,189.02 275.155552,187.16 C275.005552,186.86 274.865552,186.57 274.725552,186.27 C267.025552,170.46 256.925552,155.09 242.565552,143.5 C241.565552,142.71 240.565552,141.94 239.565552,141.19 C238.065552,140.07 236.515552,138.996667 234.915552,137.97 L233.785552,137.25 L233.365552,136.99 L233.065552,136.81 L232.895552,136.71 C232.085552,136.22 231.255552,135.71 230.425552,135.29 C229.595552,134.87 228.725552,134.39 227.865552,133.96 L227.865552,133.96 L227.745552,133.96 L227.405552,133.8 C226.735552,133.46 226.055552,133.14 225.405552,132.8 L224.705552,132.49 L224.435552,132.37 L223.305552,131.9 C218.174935,129.753345 212.831977,128.15448 207.365552,127.13 C204.338641,126.565505 201.2793,126.191437 198.205552,126.01 C193.548828,125.723381 188.874582,125.975045 184.275552,126.76 C183.575552,126.88 182.885552,127.01 182.195552,127.16 C176.382455,128.339924 170.880984,130.724462 166.045552,134.16 C159.755552,138.72 155.315552,144.83 151.285552,151.16 L150.875552,151.8 C150.195552,152.87 149.535552,153.94 148.875552,155.01 C146.565552,158.75 144.255552,162.51 141.815552,166.2 C139.555552,169.62 137.185552,172.98 134.625552,176.2 C132.05155,179.446889 129.244098,182.501663 126.225552,185.34 C125.775552,185.76 125.315552,186.18 124.845552,186.59 C119.282408,191.543201 112.878257,195.461553 105.935552,198.16 C99.6555521,200.51 92.9355521,201.57 86.4055521,200.21 L86.4055521,200.21 C84.5552593,199.833048 82.7513576,199.256336 81.0255521,198.49 C77.7655521,197.05 74.5755521,195.64 71.4355521,194.39 C65.8313393,191.977008 59.9394563,190.296494 53.9055521,189.39 L53.9055521,189.39 C47.6711167,188.555862 41.327424,189.242038 35.4155521,191.39 C34.4155521,191.74 33.4655521,192.14 32.4755521,192.58 C28.1122389,194.521395 24.1142686,197.196856 20.6555521,200.49 C20.2455521,200.88 19.8455521,201.28 19.4455521,201.68 C10.6955521,210.62 5.87555213,222.99 3.28555213,235.09 C0.873835305,246.500329 -0.216672743,258.15031 0.0355521268,269.81 L0.0355521268,269.81 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.285552,222.02 C281.157752,222.728398 279.899808,223.204377 278.585552,223.42 C273.755552,223.57 269.775552,210.49 269.775552,210.49 C269.775552,210.49 271.155552,209.1 273.345552,207.15 C279.815552,201.39 293.395552,190.76 299.765552,196.71 C306.905552,203.38 290.605552,217.52 282.285552,222.02 Z",
    id: "Path",
    fill: "#A1616A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.525552,480.01 C139.384114,481.266629 145.321017,482.125258 151.295552,482.58 C148.765552,478.11 132.295552,472.8 132.295552,472.8 L130.065552,475.4 L129.005552,476.65 L127.385552,478.55 C128.585552,478.86 129.805552,479.16 131.025552,479.45 C131.845552,479.65 132.685552,479.84 133.525552,480.01 Z",
    id: "Path",
    fill: "#A1616A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.285552,222.02 C281.157752,222.728398 279.899808,223.204377 278.585552,223.42 C273.755552,223.57 269.775552,210.49 269.775552,210.49 C269.775552,210.49 271.155552,209.1 273.345552,207.15 C274.885552,210.71 279.245552,220.25 282.285552,222.02 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.305552,217.31 C251.305552,217.31 255.305552,217.6 257.845552,215.89 C260.385552,214.18 271.345552,209.5 271.625552,206.37 C271.625552,206.37 278.165552,222.29 281.855552,222.86 C281.855552,222.86 270.485552,231.81 269.635552,234.65 C268.785552,237.49 246.635552,244.45 246.635552,244.45 L251.305552,217.31 Z",
    id: "Path",
    fill: "#FF748E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.305552,217.31 C251.305552,217.31 255.305552,217.6 257.845552,215.89 C260.385552,214.18 271.345552,209.5 271.625552,206.37 C271.625552,206.37 278.165552,222.29 281.855552,222.86 C281.855552,222.86 270.485552,231.81 269.635552,234.65 C268.785552,237.49 246.635552,244.45 246.635552,244.45 L251.305552,217.31 Z",
    id: "Path",
    fill: "#5E5A6B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.985552,476.65 C129.475552,477.4 130.145552,478.36 130.985552,479.45 C131.825552,479.65 132.665552,479.84 133.515552,480.01 C139.374114,481.266629 145.311017,482.125258 151.285552,482.58 C148.755552,478.11 132.285552,472.8 132.285552,472.8 L130.055552,475.4 L128.985552,476.65 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.155552,473.9 C129.155552,473.9 129.455552,474.46 130.045552,475.37 C131.102961,476.984058 132.268988,478.524283 133.535552,479.98 C139.394114,481.236629 145.331017,482.095258 151.305552,482.55 C154.545552,482.8 157.795552,482.92 161.025552,482.92 L162.425552,482.92 C162.810505,482.280417 163.144858,481.611712 163.425552,480.92 C164.655552,478 169.315552,472.92 174.425552,467.92 C174.665552,467.67 174.925552,467.43 175.165552,467.19 C182.455552,460.12 190.335552,453.43 190.335552,453.43 L191.095552,404.74 C191.095552,404.74 189.365552,407.05 186.905552,410.13 C182.385552,415.78 175.395552,424.03 172.115552,425.38 C167.045552,427.52 129.155552,473.9 129.155552,473.9 Z",
    id: "Path",
    fill: "#5E5A6B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.155552,473.9 C129.155552,473.9 129.455552,474.46 130.045552,475.37 C131.102961,476.984058 132.268988,478.524283 133.535552,479.98 C139.394114,481.236629 145.331017,482.095258 151.305552,482.55 C154.545552,482.8 157.795552,482.92 161.025552,482.92 L162.425552,482.92 C162.810505,482.280417 163.144858,481.611712 163.425552,480.92 C164.655552,478 169.315552,472.92 174.425552,467.92 C174.665552,467.67 174.925552,467.43 175.165552,467.19 C182.455552,460.12 190.335552,453.43 190.335552,453.43 L191.095552,404.74 C191.095552,404.74 189.365552,407.05 186.905552,410.13 C182.385552,415.78 175.395552,424.03 172.115552,425.38 C167.045552,427.52 129.155552,473.9 129.155552,473.9 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.995552,466.97 C153.200576,467.413149 157.440529,467.413149 161.645552,466.97 C169.175552,466.26 163.525552,470.81 148.995552,466.97 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.585552,471.81 C145.585552,471.81 155.535552,477.49 159.375552,474.65 C163.215552,471.81 155.675552,477.39 145.585552,471.81 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.655552,352.18 C186.04916,353.055406 186.106127,354.045217 185.815552,354.96 C185.391127,355.980245 185.246156,357.09514 185.395552,358.19 C185.455167,358.829696 185.558745,359.46453 185.705552,360.09 C185.865552,360.76 186.015552,361.21 186.015552,361.21 L187.695552,398.72 C187.659563,402.551954 187.399117,406.378509 186.915552,410.18 C186.375552,414.18 185.455552,418.29 183.915552,420.7 C180.525552,425.9 176.095552,459.9 175.175552,467.24 L175.005552,468.63 L174.945552,482.17 C185.706631,481.017748 196.220767,478.186759 206.105552,473.78 C207.685552,473.073333 209.235552,472.323333 210.755552,471.53 L211.535552,471.13 L211.915552,470.92 L211.915552,470.92 C212.605552,467.4 213.235552,464.09 213.705552,461.57 L213.765552,461.2 C213.835552,460.84 213.905552,460.5 213.965552,460.2 C214.025552,459.9 214.075552,459.58 214.135552,459.3 C214.195552,459.02 214.205552,458.89 214.245552,458.7 C214.445552,457.58 214.565552,456.94 214.565552,456.94 C214.620349,456.007631 214.750778,455.081253 214.955552,454.17 C215.455197,451.579691 216.695274,449.18985 218.525552,447.29 C219.661836,446.055354 220.4126,444.515594 220.685552,442.86 L220.685552,442.86 C221.250077,439.701386 221.347785,436.477001 220.975552,433.29 C221.167145,433.172059 221.350866,433.041784 221.525552,432.9 C222.685552,432.08 225.795552,429.44 227.475552,423.62 C227.721981,422.781598 227.922282,421.930322 228.075552,421.07 C229.785552,411.79 235.275552,391.51 235.275552,391.51 C235.275552,391.51 235.485552,390.96 235.845552,389.97 L235.845552,389.97 C235.975552,389.64 236.115552,389.25 236.265552,388.82 C236.265552,388.75 236.315552,388.68 236.335552,388.6 L236.425552,388.37 C239.295552,380.16 246.485552,357.88 245.885552,342.69 C245.115552,323.75 247.015552,313.89 247.015552,313.89 L249.385552,269.89 L249.385552,269.2 L249.385552,268.79 L249.605552,264.65 L227.805552,264 L226.535552,264 L221.355552,263.84 L221.195552,263.84 L220.635552,263.84 L213.635552,263.63 L210.505552,263.54 L204.865552,263.37 L203.955552,263.37 L202.805552,263.37 L198.455552,263.24 L185.775552,270.63 C185.775552,270.63 185.285552,271.86 184.475552,273.81 C184.305552,274.25 184.105552,274.74 183.885552,275.25 C183.665552,275.76 183.455552,276.32 183.205552,276.91 L181.405552,281.23 C181.195552,281.74 180.985552,282.23 180.765552,282.77 C178.085552,289.15 175.035552,296.21 173.495552,299.04 C171.585552,302.56 171.495552,315.04 174.125552,327.04 C175.775552,334.45 178.495552,341.7 182.535552,346.61 C183.784513,348.341641 184.831316,350.210452 185.655552,352.18 L185.655552,352.18 Z",
    id: "Path",
    fill: "#5E5A6B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.865552,453.33 C199.865552,453.33 207.635552,459.46 210.865552,459.440049 C214.095552,459.42 199.865552,453.33 199.865552,453.33 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.615552,196.9 L246.615552,209.41 L238.355552,205.85 L230.135552,202.3 L212.235552,184.68 C212.235552,184.68 198.065552,175.47 190.485552,167.09 C186.155552,162.3 183.975552,157.79 187.795552,155.41 C189.64023,154.197793 191.306359,152.733619 192.745552,151.06 C196.559605,146.573988 199.872561,141.685031 202.625552,136.48 C202.745552,136.27 202.865552,136.06 202.975552,135.85 C206.665552,129.08 209.105552,123.3 209.105552,123.3 C209.105552,123.3 219.485552,126.63 226.165552,131.3 C226.705552,131.67 227.215552,132.06 227.705552,132.46 C231.435552,135.52 233.275552,139.05 229.855552,142.58 C228.970414,143.493768 228.151665,144.469584 227.405552,145.5 L227.405552,145.5 C226.847307,146.262667 226.339556,147.061038 225.885552,147.89 C225.675552,148.26 225.485552,148.63 225.305552,149 C223.00963,153.703755 222.213748,158.999165 223.025552,164.17 L246.615552,196.9 Z",
    id: "Path",
    fill: "#A1616A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.855552,142.57 C228.970414,143.483768 228.151665,144.459584 227.405552,145.49 L227.405552,145.49 C226.847307,146.252667 226.339556,147.051038 225.885552,147.88 C225.675552,148.25 225.485552,148.62 225.305552,148.99 C220.268376,148.721185 215.383628,147.168668 211.115552,144.48 C207.952441,142.484129 205.19144,139.913074 202.975552,136.9 C202.855552,136.74 202.735552,136.57 202.625552,136.4 C202.745552,136.19 202.865552,135.98 202.975552,135.77 C206.665552,129 209.105552,123.22 209.105552,123.22 C209.105552,123.22 219.485552,126.55 226.165552,131.22 C226.705552,131.59 227.215552,131.98 227.705552,132.38 C231.435552,135.51 233.275552,139.04 229.855552,142.57 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(113.005552, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.941752,75.3613759 C162.790459,76.8454907 163.915488,78.1491051 164.764194,79.6733311 C166.422133,82.8822281 166.145809,86.6927932 165.987911,90.3228578 C165.567289,96.0022944 165.9327,101.713609 167.073465,107.2899 C168.237969,112.283746 170.389342,117.117147 170.566978,122.251382 C170.823563,129.511512 167.11294,136.290306 163.520741,142.487489 C167.451354,142.364928 171.160774,140.610786 173.784167,137.634032 C174.730975,140.894155 173.98802,144.4197 171.810431,147 C177.731639,146.719222 182.685716,142.02621 184.935775,136.510918 C186.895839,130.860312 187.471665,124.809571 186.61345,118.882041 C185.750571,112.979761 185.328303,107.019614 185.350259,101.052607 C185.747435,97.8266913 185.918923,94.5762118 185.863431,91.3256381 C185.310785,84.867733 181.402788,79.2922746 177.652689,74.0377059 L170.053806,63.4684016 C169.550503,62.6176696 168.826753,61.9238778 167.961646,61.462841 C160.796985,58.3542221 159.928542,71.791478 161.941752,75.3613759 Z",
    id: "Path",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,92.3484295 C183.997951,121.127125 163.500473,145.807091 135.25445,151.040457 C131.691047,151.675076 128.079059,151.996148 124.459795,152 L124.200404,152 C123.561903,152 122.903449,152 122.205089,152 C111.752386,151.644241 101.581759,148.512147 92.734284,142.924325 C86.4302077,138.949616 80.9219455,133.831045 76.4924185,127.831519 C61.2679636,106.999114 61.1603985,78.7154165 76.2259592,57.7673855 C91.2915199,36.8193544 118.105079,27.9694865 142.648277,35.8445687 C167.191475,43.7196508 183.884462,66.5292973 184,92.3484295 Z",
    id: "Path",
    fill: "#A1616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.146033,46.9251269 C185.607416,42.9339232 180.649355,40.6988492 175.871224,38.4438191 C174.181124,37.8063868 172.695695,36.7236401 171.572905,35.3107243 C170.750394,33.6221095 170.293966,31.7793019 170.233429,29.9026433 C168.574077,18.3880208 157.858268,10.4255695 147.182443,5.75586119 C133.447814,-0.23094429 116.954264,-2.82522667 103.759424,4.31902788 C97.3619257,7.79137506 92.2839115,13.239368 86.5061709,17.6696041 C79.1890324,23.2772452 70.7323394,27.1886248 62.9153963,32.0978053 C55.0984532,37.0069858 47.6413694,43.1733955 43.9228236,51.6147912 C38.1850674,64.6261151 42.4833865,79.5532168 43.2230972,93.7619018 C44.3426594,116.132598 35.2262244,139.541008 17.1133077,152.791804 C14.935498,154.132045 12.9964066,155.824838 11.3755515,157.800764 C9.75515894,159.84985 9.57214753,162.685367 10.9157313,164.925063 C11.8153795,166.162336 13.3147931,166.920665 14.3144022,168.018246 C16.3136204,170.373056 15.9537611,174.005051 15.1540739,176.998454 C12.548282,186.855831 7.31069201,195.822257 0,202.941278 C0.299882728,205.276132 3.13877255,206.194109 5.45786565,206.533361 C11.5876626,207.43314 17.7749068,207.886673 23.9706261,207.89037 C33.8008634,208.715902 43.4417635,204.844309 49.9604625,197.453373 C60.9561625,187.096199 70.3324958,174.144743 72.8315185,159.257554 C72.9361562,157.042451 73.6258869,154.894384 74.8307367,153.031276 C75.9674558,151.852254 77.3945551,150.992038 78.9691184,150.536774 C87.2058973,147.703019 96.5622384,149.09994 104.559111,145.627593 C114.915061,141.137489 119.953091,130.261459 125.430949,120.08389 C125.610879,122.079492 125.970738,123.955357 126.270621,125.871135 C127.851997,136.253072 127.328514,146.846293 124.731223,157.02248 C123.251801,162.769813 121.092646,168.49719 121.252583,174.444084 C121.372536,178.794496 125.850785,201.883609 131.748478,194.978827 C137.646172,188.074044 135.467024,172.827646 135.487016,164.266514 C135.497587,148.250606 138.438018,132.371246 144.163623,117.409783 C145.583068,113.678008 147.182443,110.026057 148.282013,106.174545 C148.80544,103.932113 149.473232,101.725718 150.281231,99.5691031 C151.557523,96.9130762 153.170073,94.4315582 155.079355,92.1853764 L159.297705,86.7772954 C167.174625,82.6264436 177.890434,78.3758117 182.0688,87.0566797 C183.688167,90.3893347 184.527839,94.0612421 188.66622,90.8283671 C191.145251,88.8327653 191.944938,85.1409019 192.664657,82.2871913 C195.26364,70.1938442 197.422796,56.0649833 189.146033,46.9251269 Z",
    id: "Path",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.1,
    transform: "translate(0.000000, 61.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.84,106.38 C15.3548842,106.960181 15.7431457,107.641342 15.98,108.38 C16.8151357,105.762347 16.3943904,102.905708 14.84,100.64 C13.82,99.48 12.34,98.8 11.42,97.56 L11.24,97.24 C10.2233341,99.1284278 10.2919587,101.415913 11.42,103.24 C12.34,104.52 13.82,105.22 14.84,106.38 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.76,32.72 C43.76,30.56 43.76,28.42 43.76,26.28 C43.36,18.54 41.94,10.6 41.6,2.86 C41.16,12.34 43.28,22.32 43.76,31.96 C43.76,32.2 43.74,32.46 43.76,32.72 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.32,127.64 C127.06,133.82 122.94,116.06 122.02,109.06 C121.869785,110.280588 121.809622,111.510578 121.84,112.74 C121.96,117.1 126.42,140.24 132.32,133.32 C136.32,128.64 136.7,120.66 136.46,113.32 C136.26,118.84 135.3,124.16 132.32,127.64 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.84,64.06 C127.293418,67.0408598 127.567245,70.0462797 127.66,73.06 C127.847005,68.1517848 127.572465,63.2368551 126.84,58.38 C126.54,56.38 126.18,54.52 126.02,52.58 C120.54,62.78 115.48,73.68 105.14,78.18 C97.14,81.64 87.78,80.18 79.52,83.1 C77.9453482,83.5442514 76.5211818,84.40843 75.4,85.6 C74.1831724,87.4617534 73.4921413,89.6177702 73.4,91.84 C70.9,106.76 61.52,119.84 50.5,130.12 C43.9900294,137.541355 34.3346028,141.41838 24.5,140.56 C18.301936,140.574435 12.1114287,140.126525 5.98,139.22 C5.02850554,139.088832 4.09554341,138.847201 3.2,138.5 C2.34,139.46 1.44,140.5 0.5,141.3 C0.82,143.64 3.66,144.56 5.98,144.9 C12.112031,145.803242 18.301803,146.257783 24.5,146.26 C34.3360335,147.100358 43.9863515,143.217961 50.5,135.8 C61.52,125.42 70.9,112.44 73.4,97.52 C73.4960592,95.298468 74.1867658,93.1434631 75.4,91.28 C76.5261888,90.0946292 77.9485348,89.2315552 79.52,88.78 C87.78,85.94 97.14,87.34 105.14,83.86 C115.48,79.36 120.54,68.46 126.02,58.26 C126.18,60.2 126.54,62.14 126.84,64.06 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.16,14.7 C192.52,17.56 191.72,21.34 189.26,23.26 C185.12,26.5 184.26,22.82 182.66,19.48 C178.48,10.78 167.74,15.02 159.88,19.2 L155.66,24.6 C153.752086,26.8527037 152.139088,29.3394087 150.86,32 C150.06368,34.1721916 149.395859,36.3893562 148.86,38.64 C147.78,42.48 146.18,46.16 144.74,49.9 C139.008683,64.893461 136.066983,80.8084638 136.06,96.86 C136.06,97.58 136.06,98.38 136.06,99.18 C136.460978,84.2634585 139.382183,69.5221954 144.7,55.58 C146.14,51.84 147.74,48.18 148.82,44.32 C149.353105,42.0751678 150.020981,39.8644957 150.82,37.7 C152.089497,35.0340334 153.703267,32.5461379 155.62,30.3 L159.84,24.88 C167.7,20.72 178.44,16.46 182.62,25.16 C184.22,28.5 185.08,32.18 189.22,28.94 C191.68,26.94 192.48,23.24 193.12,20.38 C194.828912,13.7263549 195.603012,6.86715962 195.42,1.42108547e-14 C195.055431,4.95192367 194.299741,9.86725258 193.16,14.7 Z",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M230.895552,191.83 C230.895552,191.83 245.895552,200.31 242.075552,193.16 L222.465552,164.16 L222.465552,164.16 L244.725552,192.77 C244.725552,192.77 258.935552,212.28 251.165552,225.77 C251.165552,225.77 250.025552,236.95 251.355552,239.6 C252.685552,242.25 250.975552,270.49 250.975552,270.49 C250.975552,270.49 245.675552,265.56 242.825552,266.49 C239.975552,267.42 219.905552,269.14 219.905552,269.14 L230.895552,191.83 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.645552,264.59 L249.365552,269.83 C247.565552,268.52 245.065552,267.06 243.365552,267.61 C240.525552,268.56 220.445552,270.27 220.445552,270.27 L221.365552,263.75 L249.645552,264.59 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.465552,191.83 C231.465552,191.83 246.465552,200.31 242.635552,193.16 L223.025552,164.16 L223.025552,164.16 L245.295552,192.77 C245.295552,192.77 259.505552,212.28 251.735552,225.77 C251.735552,225.77 250.595552,236.95 251.925552,239.6 C253.255552,242.25 251.545552,270.49 251.545552,270.49 C251.545552,270.49 246.235552,265.56 243.395552,266.49 C240.555552,267.42 220.525552,269.13 220.525552,269.13 L231.465552,191.83 Z",
    id: "Path",
    fill: "#464353",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.525552,206.37 C238.645552,215.47 234.895552,226.31 234.895552,226.31 C234.895552,226.31 232.255552,253.22 228.895552,261.18 C225.535552,269.14 226.995552,280.12 225.095552,300.39 C224.415552,307.69 222.095552,312.7 218.895552,316.09 C213.675552,321.66 206.225552,322.82 200.345552,322.47 C199.865552,322.47 199.405552,322.41 198.955552,322.37 C189.475552,321.37 180.385552,275.76 180.385552,275.76 C180.385552,275.76 176.035552,236.92 177.735552,231.62 C179.435552,226.32 176.035552,196 174.895552,189.37 C174.175552,185.17 176.345552,178.3 178.025552,173.83 C179.025552,171.25 179.815552,169.47 179.815552,169.47 C179.815552,169.47 183.035552,159.24 188.345552,153.94 C189.819249,152.420702 191.848972,151.568363 193.965552,151.579882 C196.453566,151.674575 198.87076,152.434264 200.965552,153.78 L201.205552,153.94 C201.205552,153.94 235.695552,189.18 238.905552,197.32 C239.745552,199.6 239.835552,202.9 239.525552,206.37 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.355552,205.8 C237.475552,214.9 233.735552,225.74 233.735552,225.74 C233.735552,225.74 231.085552,252.65 227.675552,260.61 C224.265552,268.57 225.775552,279.55 223.885552,299.83 C223.205552,307.12 220.885552,312.14 217.675552,315.52 C212.455552,321.09 205.015552,322.25 199.125552,321.91 L197.735552,321.8 C188.265552,320.86 179.165552,275.19 179.165552,275.19 C179.165552,275.19 174.815552,236.35 176.515552,231.05 C178.215552,225.75 174.815552,195.43 173.675552,188.8 C172.955552,184.6 175.125552,177.73 176.805552,173.26 C177.805552,170.68 178.595552,168.9 178.595552,168.9 C178.595552,168.9 181.825552,158.67 187.125552,153.37 C188.60322,151.856528 190.630351,151.005278 192.745552,151.00998 C195.233566,151.104575 197.65076,151.864264 199.745552,153.21 L199.995552,153.37 C199.995552,153.37 234.475552,188.61 237.695552,196.76 C238.605552,199.03 238.705552,202.29 238.355552,205.8 Z",
    id: "Path",
    fill: "#5E5A6B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.725552,344.49 C199.725552,344.49 191.915552,351.49 189.215552,351.17 C186.515552,350.85 199.725552,344.49 199.725552,344.49 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.805552,351.18 C201.805552,351.18 193.565552,355 191.105552,355.57 C188.645552,356.14 198.625552,350.19 201.805552,351.18 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.685552,246.58 C233.685552,246.58 245.905552,246.73 247.755552,250.58 C249.605552,254.43 237.665552,245.02 233.685552,246.58 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.985552,253.26 C231.985552,253.26 241.365552,255.26 244.205552,257.53 C247.045552,259.8 231.985552,253.26 231.985552,253.26 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.215552,230.1 C216.215552,230.1 215.085552,268.61 210.885552,273.58 C206.685552,278.55 216.215552,230.1 216.215552,230.1 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.695552,338.95 C205.695552,338.95 197.895552,372.95 213.585552,375.04 C229.275552,377.13 224.455552,336.39 224.455552,336.39 L205.695552,338.95 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.125552,338.38 C205.125552,338.38 197.325552,372.38 213.015552,374.47 C228.705552,376.56 223.885552,335.82 223.885552,335.82 L205.125552,338.38 Z",
    id: "Path",
    fill: "#A1616A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.525552,195.82 C217.715552,175.41 189.165552,171.19 182.525552,190.49 C182.475552,190.62 182.435552,190.75 182.395552,190.88 C178.035552,203.96 179.925552,237.06 179.925552,237.06 C179.925552,237.06 180.495552,259.28 182.585552,266.67 C184.675552,274.06 190.535552,295.28 190.535552,298.67 C190.535552,302.06 195.985552,315.15 198.275552,316.1 C200.565552,317.05 201.735552,324.43 202.275552,325.76 C202.815552,327.09 204.525552,344.35 204.525552,344.35 C204.525552,344.35 225.935552,343.02 226.315552,339.61 C226.695552,336.2 221.575552,319.53 221.575552,319.53 C221.575552,319.53 217.805552,312.71 217.325552,307.21 C216.845552,301.71 213.815552,299.21 214.375552,295.47 C214.935552,291.73 212.675552,289.78 212.675552,287.32 C212.675552,284.86 210.965552,278.22 210.965552,278.22 C210.965552,278.22 207.365552,275.38 207.965552,271.97 C208.565552,268.56 202.855552,261.74 204.365552,259.28 C205.875552,256.82 206.265552,250.75 206.265552,250.75 C206.265552,250.75 208.155552,223.47 209.485552,216.08 C210.815552,208.69 218.575552,196.76 218.575552,196.76 C218.575552,196.76 218.575552,196.42 218.525552,195.82 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.675552,315.52 C212.455552,321.09 205.015552,322.25 199.125552,321.91 C198.455552,319.32 197.455552,316.15 196.005552,315.55 C193.705552,314.6 188.265552,301.55 188.265552,298.12 C188.265552,294.69 182.395552,273.49 180.265552,266.12 C178.135552,258.75 177.615552,236.51 177.615552,236.51 C177.615552,236.51 175.715552,203.41 180.075552,190.34 C180.075552,190.2 180.165552,190.07 180.205552,189.94 C186.875552,170.64 215.435552,174.86 216.205552,195.27 C216.205552,195.87 216.205552,196.21 216.205552,196.21 C216.205552,196.21 208.435552,208.14 207.115552,215.53 C205.795552,222.92 203.885552,250.2 203.885552,250.2 C203.885552,250.2 203.505552,256.27 201.995552,258.73 C200.485552,261.19 206.165552,268.02 205.595552,271.43 C205.025552,274.84 208.595552,277.68 208.595552,277.68 C208.595552,277.68 210.295552,284.31 210.295552,286.77 C210.295552,289.23 212.575552,291.13 212.005552,294.92 C211.435552,298.71 214.475552,301.17 214.955552,306.67 C215.406424,309.741261 216.323663,312.725661 217.675552,315.52 L217.675552,315.52 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.415552,195.25 C216.615552,174.84 188.055552,170.62 181.415552,189.92 C181.415552,190.05 181.325552,190.18 181.285552,190.32 C176.925552,203.39 178.825552,236.49 178.825552,236.49 C178.825552,236.49 179.385552,258.71 181.475552,266.1 C183.565552,273.49 189.475552,294.71 189.475552,298.1 C189.475552,301.49 194.915552,314.58 197.215552,315.53 C199.515552,316.48 200.665552,323.86 201.215552,325.19 C201.765552,326.52 203.485552,343.76 203.485552,343.76 C203.485552,343.76 224.885552,342.43 225.265552,339.02 C225.645552,335.61 220.525552,318.96 220.525552,318.96 C220.525552,318.96 216.755552,312.14 216.265552,306.64 C215.775552,301.14 212.755552,298.69 213.325552,294.9 C213.895552,291.11 211.615552,289.21 211.615552,286.75 C211.615552,284.29 209.915552,277.66 209.915552,277.66 C209.915552,277.66 206.315552,274.81 206.915552,271.4 C207.515552,267.99 201.795552,261.17 203.315552,258.71 C204.835552,256.25 205.205552,250.18 205.205552,250.18 C205.205552,250.18 207.105552,222.9 208.425552,215.51 C209.745552,208.12 217.525552,196.19 217.525552,196.19 C217.525552,196.19 217.445552,195.9 217.415552,195.25 Z",
    id: "Path",
    fill: "#5E5A6B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.245552,247.72 C182.815552,247.15 193.615552,235.22 197.025552,239.48 C200.435552,243.74 182.245552,247.72 182.245552,247.72 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.245552,256.96 C183.665552,256.53 194.045552,256.11 196.605552,250.28 C199.165552,244.45 183.245552,256.96 183.245552,256.96 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.425552,213.9 L287.015552,214.31 C286.502837,213.957934 286.151376,213.416237 286.038797,212.804556 C285.926217,212.192876 286.061784,211.561542 286.415552,211.05 L312.745552,172.82 C313.482066,171.757145 314.938884,171.489019 316.005552,172.22 L315.425552,171.82 C316.25282,172.380033 316.82321,173.246262 317.010826,174.227491 C317.198441,175.20872 316.987857,176.224274 316.425552,177.05 L291.665552,212.9 C291.10366,213.727932 290.235682,214.29853 289.252823,214.486098 C288.269964,214.673667 287.252855,214.462818 286.425552,213.9 L286.425552,213.9 Z",
    id: "Path",
    fill: "#464353",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.115191,167.071935 L301.835191,167.071935 L301.835191,218.181935 L301.115191,218.181935 C300.154215,218.181935 299.375191,217.402911 299.375191,216.441935 L299.375191,168.811935 C299.375191,167.85096 300.154215,167.071935 301.115191,167.071935 L301.115191,167.071935 Z",
    id: "Path",
    fill: "#9F9EFF",
    fillRule: "nonzero",
    transform: "translate(300.605191, 192.626935) rotate(34.560000) translate(-300.605191, -192.626935) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#464353",
    fillRule: "nonzero",
    transform: "translate(311.204141, 179.408284) rotate(34.560000) translate(-311.204141, -179.408284) ",
    x: 310.969141,
    y: 177.323284,
    width: 1,
    height: 4.17,
    rx: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.235552,822.57 L806.235552,797.11 C806.235552,797.11 799.535552,779.04 800.615552,769.35 C801.695552,759.66 798.365552,749.08 798.365552,749.08 L804.945552,714.83 C804.945552,714.83 805.305552,711.1 805.285552,706.18 C805.285552,697.98 804.125552,686.48 798.445552,683.49 C789.365552,678.7 770.755552,638.21 766.855552,638.21 C762.955552,638.21 750.415552,635.6 750.415552,631.21 C750.430296,631.05034 750.430296,630.88966 750.415552,630.73 C750.415552,630.73 750.415552,630.63 750.415552,630.58 C750.415552,630.53 750.355552,630.35 750.315552,630.23 L750.255552,630.06 L750.075552,629.66 L750.015552,629.55 C749.526024,628.67924 748.916753,627.881465 748.205552,627.18 C765.145552,623.95 782.005552,620.4 798.745552,616.27 L798.125552,616.27 L798.745552,616.12 C796.521783,616.097212 794.30128,615.943614 792.095552,615.66 L791.605552,615.77 C766.985552,612.41 744.855552,593.16 738.835552,568.77 C732.155552,541.77 743.835552,513.59 743.315552,485.77 C742.955106,468.164921 737.725071,451.00376 728.205552,436.19 C726.925552,434.19 725.565552,432.27 724.145552,430.39 C734.123855,425.542067 741.485409,416.575782 744.297973,405.844591 C747.110537,395.1134 745.093231,383.688986 738.775552,374.57 C738.345552,373.95 737.895552,373.35 737.435552,372.76 C746.620858,387.998674 744.039088,407.565336 731.215552,419.9 C737.765664,408.000785 737.422044,393.500846 730.315624,381.925264 C723.209204,370.349682 710.434529,363.48135 696.859282,363.937389 C683.284035,364.393427 670.999101,372.103596 664.685552,384.13 C663.875552,383.77 663.065552,383.41 662.255552,383.08 C667.405967,368.983228 680.415887,359.27486 695.395552,358.35 C694.645552,358.3 693.905552,358.28 693.145552,358.28 C677.917558,358.302193 664.195698,367.476394 658.355552,381.54 C647.035552,377.39 635.225552,375.67 623.605552,378.62 C621.445717,379.164921 619.337684,379.897714 617.305552,380.81 L617.825552,380.4 C614.942169,381.616936 612.282253,383.306845 609.955552,385.4 C606.475552,388.61 604.025552,392.77 601.075552,396.49 C598.068081,400.202728 594.510248,403.433443 590.525552,406.07 C590.855552,405.91 591.185552,405.72 591.525552,405.55 C578.125552,415.03 559.915552,417.76 544.595552,411.66 C540.295552,409.94 536.145552,407.59 531.595552,406.96 C528.093081,406.526387 524.538481,407.044551 521.305552,408.46 C521.445552,408.35 521.575552,408.23 521.725552,408.12 C517.495774,409.858459 513.778811,412.646182 510.925552,416.22 C505.925552,422.39 503.415552,430.22 501.625552,437.93 C500.295267,443.403772 499.623841,449.016898 499.625552,454.65 C499.695552,461.87 501.315552,468.84 505.625552,474.49 C512.305552,483.15 521.425552,485.49 530.945552,487.05 C530.665552,488.05 530.395552,488.97 530.155552,489.95 C518.803513,534.853023 545.050935,580.681013 589.525552,593.61 L591.375552,596.75 L591.975552,596.89 C596.405552,604.38 601.255552,612.79 605.755552,620.89 C605.995552,621.32 606.225552,621.75 606.465552,622.17 L597.955552,626.55 L597.955552,626.55 C595.725552,627.7 590.185552,630.71 587.115552,633.67 C586.228728,634.436711 585.542234,635.4081 585.115552,636.5 C583.815552,640.86 576.895552,652.18 572.115552,655.22 C567.335552,658.26 563.455552,673.07 563.895552,680.89 C564.335552,688.71 561.295552,687.89 553.505552,688.31 C545.715552,688.73 553.505552,700.06 553.505552,700.06 L553.705552,700.82 C553.345552,701.44 552.935552,702.11 552.485552,702.82 C550.485552,705.89 547.855552,709.29 545.935552,709.11 C542.465552,708.78 540.305552,717.27 540.525552,718.57 C540.745552,719.87 534.465552,730.32 532.085552,731.41 C529.705552,732.5 519.535552,734.58 522.345552,744.32 L510.005552,756.88 L500.005552,766.46 C500.005552,766.46 485.725552,758.4 462.565552,783.46 C465.148052,783.216447 467.753321,783.460691 470.245552,784.18 L469.585552,784.5 C463.485552,787.39 452.925552,792.32 445.115552,795.5 L403.525552,796.79 L403.525552,765.79 C403.525552,765.79 399.845552,757.09 395.525552,765.79 L394.435552,797.11 L304.035552,800.04 L320.975552,782.04 L320.975552,782.04 L321.195552,781.8 C324.887379,777.877638 326.162122,772.261876 324.525552,767.13 L253.845552,544.96 L253.845552,544.96 L253.355552,543.4 C251.937431,538.918266 248.063167,535.655318 243.405552,535.02 L145.225552,521.77 L144.545552,521.68 L135.525552,524.13 C133.238645,524.754109 131.298222,526.270564 130.139969,528.338873 C128.981715,530.407183 128.702693,532.854023 129.365552,535.13 C131.685552,543.13 135.495552,556.19 140.365552,572.6 L126.805552,572.6 L137.195552,662.28 L143.525552,696.78 C145.145552,705.58 147.035552,714.326667 149.195552,723.02 C154.405552,744.02 164.715552,788.81 164.945552,814.79 L88.9455521,897.65 L88.9455521,914.48 L574.395552,914.48 C574.416153,914.536156 574.442988,914.589825 574.475552,914.64 L810.985552,914.64 C810.985552,914.64 808.395552,910.07 813.985552,903.54 C819.575552,897.01 816.805552,871.11 816.805552,871.11 C816.805552,871.11 813.665552,866.97 817.505552,857.83 C821.345552,848.69 814.235552,822.57 814.235552,822.57 Z M211.045552,803.02 L198.145552,803.44 L186.145552,725.38 C195.035552,753.9 203.655552,781.04 211.045552,803.02 Z M543.225552,850.46 L534.855552,833.38 C536.771707,833.467584 538.668144,832.961169 540.285552,831.93 C545.695552,828.01 548.935552,818.87 548.935552,818.87 L563.455552,801.62 L564.655552,800.18 C567.595552,808.39 571.055552,814.87 573.825552,818 C580.745552,825.84 581.615552,848.47 583.745552,856.74 C585.875552,865.01 584.215552,861.53 583.745552,866.32 C583.678104,867.491176 583.775727,868.666018 584.035552,869.81 C574.465552,859.54 560.855552,850.2 543.225552,850.46 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#514E7F",
    fillRule: "nonzero",
    points: "93.8355521 897.98 179.185552 805.47 518.185552 794.56 577.365552 914.64 93.8355521 914.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.2,
    points: "93.8355521 897.98 179.185552 805.47 518.185552 794.56 577.365552 914.64 93.8355521 914.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.425552,890.26 L535.425552,893.46 C535.425552,896.906257 532.631809,899.7 529.185552,899.7 L346.965552,899.7 C343.515552,899.7 346.965552,892.81 346.965552,892.81 L344.905552,847.68 C344.745805,844.145126 347.094571,840.985576 350.525552,840.12 C360.665552,837.56 367.645552,841.67 367.645552,841.67 L480.525552,838.8 C482.864067,838.683298 485.208388,838.793816 487.525552,839.13 C495.804082,840.228384 503.276364,844.656136 508.215552,851.39 L534.155552,886.56 C534.964528,887.625327 535.409747,888.922423 535.425552,890.26 Z",
    id: "Path",
    fill: "#514E7F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.425552,893.46 L535.425552,893.46 C535.425552,896.906257 532.631809,899.7 529.185552,899.7 L346.965552,899.7 C343.515552,899.7 346.965552,892.81 346.965552,892.81 C346.965552,892.81 357.025552,887.93 371.965552,888.81 L504.965552,885.93 C504.965552,885.93 520.675552,886.29 529.865552,887.29 C533.019459,887.631139 535.413396,890.287721 535.425552,893.46 L535.425552,893.46 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero",
    points: "483.705552 846.55 369.365552 846.55 372.525552 881.32 504.965552 879.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.795552,870.97 L289.795552,883.04 L170.005552,887.9 C170.005552,887.9 142.615552,886.03 139.255552,869.2 C138.98824,867.440436 139.022055,865.648228 139.355552,863.9 C140.565552,856.81 146.645552,844.43 173.445552,838.71 L206.445552,835.32 L280.025552,835.32 C280.025552,835.32 289.525552,844.83 289.795552,870.97 Z",
    id: "Path",
    fill: "#514E7F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.795552,871.35 L289.795552,883.04 L170.005552,887.9 C170.005552,887.9 142.615552,886.03 139.255552,869.2 C138.98824,867.440436 139.022055,865.648228 139.355552,863.9 C139.355552,863.9 155.915552,879.56 178.355552,877.26 L283.795552,872.67 C285.817023,872.334 287.819711,871.893409 289.795552,871.35 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1,
    transform: "translate(197.831555, 852.886257) rotate(-2.950000) translate(-197.831555, -852.886257) ",
    cx: 197.831555,
    cy: 852.886257,
    rx: 36.83,
    ry: 6.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.525552,849.9 L190.145552,859.48 L169.525552,854.6 L169.425552,820.99 C170.735552,796.46 159.425552,747.36 153.835552,725.11 C151.682219,716.51 149.798885,707.843333 148.185552,699.11 L141.845552,664.96 L131.525552,576.22 L156.085552,576.22 L170.525552,596.9 L209.525552,849.9 Z",
    id: "Path",
    fill: "#514E7F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.525552,849.9 L190.145552,859.48 L177.785552,787.7 C178.025552,775.47 162.695552,717.41 161.695552,715.02 C149.475552,685.85 139.005552,576.26 139.005552,576.26 L156.095552,576.26 L170.525552,596.9 L209.525552,849.9 Z",
    id: "Path",
    fill: "#514E7F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.525552,849.9 L190.145552,859.48 L177.785552,787.7 C178.025552,775.47 162.695552,717.41 161.695552,715.02 C149.475552,685.85 139.005552,576.26 139.005552,576.26 L156.095552,576.26 L170.525552,596.9 L209.525552,849.9 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.055552,783.32 L259.055552,852.87 L251.315552,853.42 L241.885552,854.1 C237.415562,854.422132 233.223693,851.90621 231.405552,847.81 C211.405552,802.81 147.465552,585.22 134.005552,539.13 C133.343946,536.871079 133.621449,534.440787 134.775255,532.389159 C135.929061,530.33753 137.861621,528.838019 140.135552,528.23 L149.135552,525.81 L149.805552,525.89 L245.955552,538.79 C251.562482,539.544953 256.233587,543.460896 257.955552,548.85 L328.335552,768.78 C329.975979,773.86214 328.71898,779.434328 325.055552,783.32 L325.055552,783.32 Z",
    id: "Path",
    fill: "#514E7F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.055552,783.32 L259.055552,852.87 L251.315552,853.42 L241.885552,854.1 C237.415562,854.422132 233.223693,851.90621 231.405552,847.81 C211.405552,802.81 147.465552,585.22 134.005552,539.13 C133.343946,536.871079 133.621449,534.440787 134.775255,532.389159 C135.929061,530.33753 137.861621,528.838019 140.135552,528.23 L149.135552,525.81 L149.805552,525.89 L245.955552,538.79 C251.562482,539.544953 256.233587,543.460896 257.955552,548.85 L328.335552,768.78 C329.975979,773.86214 328.71898,779.434328 325.055552,783.32 L325.055552,783.32 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.825552,783.56 L259.055552,852.9 L251.315552,853.45 L152.615552,537.45 C150.935502,533.821758 149.9939,529.895585 149.845552,525.9 L247.605552,539.02 C252.232038,539.641464 256.086411,542.872908 257.505552,547.32 L328.275552,768.47 C329.964711,773.752722 328.642463,779.536121 324.825552,783.56 L324.825552,783.56 Z",
    id: "Path",
    fill: "#514E7F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.005552,771.9 C319.283426,773.123048 318.387396,774.234664 317.345552,775.2 L252.595552,835.4 L164.255552,542.61 L249.085552,551.01 C255.09041,551.600034 260.143436,555.760188 261.875552,561.54 L321.465552,759.97 C322.671718,763.975596 322.142069,768.303484 320.005552,771.9 L320.005552,771.9 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.005552,771.9 L249.085552,551.01 C255.09041,551.600034 260.143436,555.760188 261.875552,561.54 L321.465552,759.97 C322.671718,763.975596 322.142069,768.303484 320.005552,771.9 L320.005552,771.9 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#945B79",
    fillRule: "nonzero",
    cx: 700.275552,
    cy: 407.15,
    r: 37.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.335552,401.58 C662.331916,381.709038 677.809977,365.275378 697.645552,364.09 C696.905552,364.09 696.165552,364.02 695.415552,364.02 C681.852384,363.798669 669.223703,370.90781 662.377422,382.618359 C655.53114,394.328907 655.53114,408.821093 662.377422,420.531641 C669.223703,432.24219 681.852384,439.351331 695.415552,439.13 C696.165552,439.13 696.905552,439.13 697.645552,439.06 C677.813829,437.874852 662.337207,421.447104 662.335552,401.58 L662.335552,401.58 Z",
    id: "Path",
    fill: "#945B79",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.195552,407.15 C667.197838,387.275625 682.685941,370.844996 702.525552,369.67 C701.785552,369.67 701.035552,369.6 700.285552,369.6 C679.783404,369.934565 663.338394,386.650123 663.338394,407.155 C663.338394,427.659877 679.783404,444.375435 700.285552,444.71 C701.035552,444.71 701.785552,444.71 702.525552,444.63 C682.683668,443.459868 667.192847,427.026357 667.195552,407.15 L667.195552,407.15 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.005552,828.18 C503.497988,830.032677 499.885164,831.678816 496.185552,833.11 C486.525552,836.91 471.805552,841.27 458.095552,839.6 C435.045552,836.8 421.255552,844.34 421.255552,844.34 L416.085552,805.99 C416.085552,805.99 433.085552,800.99 439.995552,799.74 C445.175552,798.74 463.865552,790.13 472.835552,785.9 C475.835552,784.5 477.705552,783.58 477.705552,783.58 L494.945552,783.58 L507.005552,828.18 Z",
    id: "Path",
    fill: "#FFC1C7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.005552,828.18 C503.497988,830.032677 499.885164,831.678816 496.185552,833.11 C495.015552,798.96 481.915552,788.82 472.835552,785.9 C475.835552,784.5 477.705552,783.58 477.705552,783.58 L494.945552,783.58 L507.005552,828.18 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.785552,713.56 L570.785552,797.56 L566.275552,802.9 L551.825552,820 C551.825552,820 548.595552,829 543.205552,832.92 C537.815552,836.84 525.525552,831.63 525.525552,831.63 L522.075552,837.23 C522.075552,837.23 514.325552,838.74 510.665552,837.23 C507.005552,835.72 497.945552,841.54 497.945552,841.54 C499.245552,779.92 465.845552,784.88 465.845552,784.88 C488.895552,760.1 503.115552,768.07 503.115552,768.07 L513.035552,758.59 L525.315552,746.15 C522.515552,736.52 532.635552,734.46 535.005552,733.38 C537.375552,732.3 543.625552,721.96 543.415552,720.67 C543.205552,719.38 545.345552,710.97 548.795552,711.3 C550.715552,711.48 553.345552,708.11 555.325552,705.08 C556.905552,702.64 558.065552,700.42 558.065552,700.42 L570.785552,713.56 Z",
    id: "Path",
    fill: "#FF6584",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.615552,629.59 L626.015552,616.59 L624.575552,631.82 L629.575552,647.12 C629.575552,647.12 624.985552,658.97 624.415552,660.26 C623.845552,661.55 612.925552,688.56 612.925552,688.56 L604.165552,677.5 L600.615552,629.59 Z",
    id: "Path",
    fill: "#FF6584",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1,
    points: "604.175552 677.5 600.615552 629.59 626.015552 616.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.755552,615.31 C709.755552,615.31 701.315552,627.45 689.755552,642.92 C662.855552,678.92 619.095552,732.92 625.755552,693.74 C625.975552,692.46 626.145552,691.18 626.295552,689.89 C624.655552,690.99 620.895552,690.03 616.795552,688.08 L616.515552,687.95 C614.493382,686.959145 612.542071,685.829791 610.675552,684.57 C610.465552,684.44 610.265552,684.3 610.065552,684.16 C605.515552,680.99 601.875552,677.28 602.065552,674.72 C605.295552,618.48 618.385552,645.3 622.065552,651.54 C622.273584,651.976946 622.558059,652.37318 622.905552,652.71 C622.745552,652.27 622.565552,651.81 622.365552,651.33 C619.785552,645 614.855552,635.54 609.225552,625.43 L609.225552,625.33 L608.475552,623.99 C603.795552,615.64 598.725552,606.91 594.165552,599.25 L592.935552,597.19 C585.735552,585.11 580.135552,576.1 580.135552,576.1 C580.135552,576.1 612.845552,546.18 640.415552,528 C663.415552,512.81 682.895552,505.8 676.665552,531.28 C672.665552,547.66 673.835552,561.67 677.525552,573.28 C677.655552,573.71 677.795552,574.14 677.945552,574.56 C678.686298,576.772605 679.540768,578.945496 680.505552,581.07 C681.813018,583.997467 683.309511,586.836794 684.985552,589.57 C691.260423,599.858247 699.715809,608.644748 709.755552,615.31 Z",
    id: "Path",
    fill: "#FFC1C7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.905552,569.9 C643.395552,586.75 640.095552,602.900019 615.385552,602.900019 C608.196623,602.904775 601.036127,601.997532 594.075552,600.2 C586.285552,587.1 580.075552,577.05 580.075552,577.05 C580.075552,577.05 690.295552,476.26 676.605552,532.23 C672.425552,549.14 654.895552,558 658.905552,569.9 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.276411,515.34 C700.276411,549.679755 679.589249,580.638008 647.863065,593.778329 C616.136882,606.918649 579.619094,599.653133 555.338651,575.369829 C531.058208,551.086526 523.796993,514.567882 536.94105,482.843247 C550.085108,451.118612 581.045798,430.435955 615.385552,430.439185 C637.931697,430.341071 659.582848,439.254417 675.524595,455.198041 C691.466342,471.141666 700.377137,492.793866 700.276411,515.34 Z",
    id: "Path",
    fill: "#FFC1C7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.445552,662.28 C613.445552,662.28 614.955552,686.41 630.255552,684.47 C645.555552,682.53 633.915552,735.75 633.915552,735.75 L616.915552,751.26 L598.575552,756.9 C598.575552,756.9 582.415552,752.16 582.635552,751.29 C582.855552,750.42 589.095552,700.02 589.095552,700.02 L598.575552,673.08 L613.445552,662.28 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.445552,664 C613.445552,664 614.955552,688.13 630.255552,686.2 C645.555552,684.27 633.915552,737.48 633.915552,737.48 L616.915552,752.99 L598.595552,758.59 C598.595552,758.59 582.435552,753.85 582.655552,752.99 C582.875552,752.13 589.115552,701.71 589.115552,701.71 L598.595552,674.78 L613.445552,664 Z",
    id: "Path",
    fill: "#514E7F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.785552,713.56 L570.785552,797.56 L566.275552,802.9 C561.625552,790.56 558.085552,773.83 560.275552,758.79 C563.125552,738.85 557.445552,713.33 555.385552,705.06 C556.965552,702.62 558.125552,700.4 558.125552,700.4 L570.785552,713.56 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.385552,666.59 C614.839523,671.32237 613.61006,675.950537 611.735552,680.33 C611.175552,681.66 610.605552,682.95 610.035552,684.16 C605.485552,680.99 601.845552,677.28 602.035552,674.72 C605.265552,618.48 618.355552,645.3 622.035552,651.54 C620.235552,652.9 616.215552,656.9 615.385552,666.59 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.315552,651.33 C619.615552,644.7 614.315552,634.63 608.385552,623.99 L609.135552,623.61 L622.855552,650.99 C622.663672,651.083266 622.482591,651.19728 622.315552,651.33 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.755552,615.31 C709.755552,615.31 616.245552,749.76 625.755552,693.74 C625.975552,692.46 626.145552,691.18 626.295552,689.89 C624.615552,691.01 620.725552,689.99 616.515552,687.95 C617.155552,684.21 617.515552,681.65 617.515552,681.65 L627.865552,652.37 C627.865552,652.37 633.865552,629.1 633.035552,624.37 L633.315552,624.18 L684.775552,589.63 L684.825552,589.63 L684.825552,589.63 C691.153446,599.913344 699.664231,608.68017 709.755552,615.31 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.715552,717.01 L799.385552,754.9 L777.385552,914.77 L586.525552,914.77 C586.525552,914.77 589.965552,886.77 589.965552,882.45 C589.965552,878.13 586.095552,871.68 586.525552,866.94 C586.955552,862.2 588.605552,865.64 586.525552,857.46 C584.445552,849.28 583.525552,826.86 576.655552,819.11 C569.785552,811.36 558.525552,782.9 561.955552,758.81 C565.385552,734.72 556.345552,702.36 556.345552,702.36 C556.345552,702.36 548.595552,691.15 556.345552,690.72 C564.095552,690.29 567.125552,691.11 566.695552,683.38 C566.265552,675.65 570.135552,660.99 574.875552,657.97 C579.615552,654.95 586.515552,643.75 587.805552,639.44 C588.235767,638.355704 588.921958,637.391606 589.805552,636.63 C593.685552,632.91 601.575552,629.1 601.575552,629.1 L609.115552,625.33 L609.115552,625.43 L622.795552,652.71 C622.795552,652.71 616.395552,655.82 615.325552,668.31 C614.780914,673.042634 613.551399,677.670999 611.675552,682.05 C611.315552,682.91 610.955552,683.76 610.585552,684.57 C609.485552,687.01 608.365552,689.17 607.415552,690.89 L607.415552,690.89 C606.005552,693.44 604.995552,695.01 604.995552,695.01 C604.995552,695.01 604.625552,697.93 604.065552,702.01 L604.065552,702.01 C602.915552,710.39 600.975552,723.67 599.825552,726.85 C598.825552,729.67 596.825552,734.52 595.715552,738.85 C595.015552,741.56 594.615552,744.07 594.985552,745.71 C594.985552,745.84 595.045552,745.97 595.085552,746.09 C596.375552,750.09 602.835552,732.89 602.835552,732.89 C602.835552,732.89 607.575552,718.24 609.735552,718.24 C611.385552,718.24 615.095552,697.56 616.735552,688.02 C617.215552,685.17 617.505552,683.32 617.505552,683.32 L627.855552,654.03 C627.855552,654.03 629.285552,648.5 630.655552,642.28 C632.095552,635.74 633.465552,628.45 633.025552,626.02 L633.305552,625.83 L684.765552,591.28 L684.815552,591.28 L685.605552,590.75 L685.525552,590.75 C685.165552,590.75 684.125552,590.11 682.135552,585.43 C681.625552,584.24 681.055552,582.8 680.425552,581.02 C680.425552,581.02 696.885552,574.41 702.755552,579.25 C703.136719,579.554935 703.473319,579.911731 703.755552,580.31 C703.922032,580.531851 704.066072,580.769684 704.185552,581.02 C708.065552,589.02 709.785552,595.02 713.665552,600.2 C714.085829,600.751079 714.540042,601.275429 715.025552,601.77 C719.715552,606.68 729.025552,612.43 727.455552,613.99 C725.735552,615.71 740.385552,622.99 740.385552,622.99 C740.385552,622.99 748.955552,627.89 751.645552,631.99 C752.116731,632.624387 752.394542,633.381422 752.445552,634.17 C752.445552,638.48 764.945552,641.06 768.825552,641.06 C772.705552,641.06 791.235552,681.14 800.275552,685.88 C809.315552,690.62 806.715552,717.01 806.715552,717.01 Z",
    id: "Path",
    fill: "#FF6584",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.1,
    transform: "translate(585.005552, 577.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.37,75.71 C28.37,75.71 21.97,78.82 20.9,91.31 C20.3566637,96.0439942 19.1236044,100.67302 17.24,105.05 C15.989124,108.073541 14.5702448,111.024809 12.99,113.89 L12.99,113.89 C11.58,116.44 10.57,118.01 10.57,118.01 C10.57,118.01 10.2,120.93 9.64,125.01 L9.64,125.01 C8.52,133.46 6.52,146.74 5.39,149.9 C4.39,152.72 2.39,157.57 1.28,161.9 C0.58,164.61 0.18,167.12 0.55,168.76 C0.55,168.89 0.61,169.02 0.65,169.14 C1.94,173.14 8.4,155.94 8.4,155.94 C8.4,155.94 13.14,141.29 15.3,141.29 C15.91,141.29 16.81,138.43 17.78,134.35 C18.27,131.08 18.78,127.81 19.11,125.07 L19.11,125.07 C19.67,120.97 20.04,118.07 20.04,118.07 C20.04,118.07 20.61,117.19 21.49,115.67 C22.41,110.4 23.05,106.42 23.05,106.42 L33.4,77.13 C33.4,77.13 34.15,74.21 35.09,70.24 L24.09,48.37 L16.55,52.14 L16.55,52.14 L28.37,75.71 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.24,108.98 C206.24,104.24 187.67,64.16 183.79,64.16 C179.91,64.16 167.41,61.58 167.41,57.27 C167.41,52.96 155.35,46.06 155.35,46.06 C155.35,46.06 140.7,38.74 142.42,37.06 C143.97,35.5 134.68,29.75 129.99,24.84 C129.506824,24.3432813 129.052735,23.8190754 128.63,23.27 C124.75,18.09 123.03,12.06 119.15,4.09 C119.028314,3.83771675 118.884413,3.59676594 118.72,3.37 C118.432393,2.97616599 118.096427,2.62004175 117.72,2.31 C115.08,0.14 110.32,0.31 105.86,1.09 C106.723006,1.34335226 107.530462,1.75725844 108.24,2.31 C108.616427,2.62004175 108.952393,2.97616599 109.24,3.37 C109.404413,3.59676594 109.548314,3.83771675 109.67,4.09 C113.55,12.09 115.27,18.09 119.15,23.27 C119.577176,23.8056575 120.034587,24.3164888 120.52,24.8 C125.21,29.71 134.52,35.46 132.95,37.02 C131.23,38.74 145.88,46.02 145.88,46.02 C145.88,46.02 157.94,52.92 157.94,57.23 C157.94,61.54 170.44,64.12 174.32,64.12 C178.2,64.12 196.73,104.2 205.77,108.94 C214.81,113.68 212.24,139.94 212.24,139.94 L204.9,177.9 L182.9,337.77 L192.38,337.77 L214.38,177.9 L221.71,139.98 C221.71,139.98 224.29,113.72 215.24,108.98 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.925552,806.77 C423.925552,806.77 369.115552,790.91 365.235552,815.26 C361.355552,839.61 387.645552,853.61 404.445552,853.18 C421.245552,852.75 428.575552,836.8 428.575552,836.8 L423.925552,806.77 Z",
    id: "Path",
    fill: "#FFC1C7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.765552,881.62 C698.765552,881.62 686.485552,890.45 660.415552,890.45 C634.345552,890.45 603.965552,896.05 603.965552,896.05 C603.965552,896.05 565.185552,804.7 487.405552,882.9 C487.405552,882.9 473.405552,901 546.005552,902.9 C546.005552,902.9 571.645552,902.04 577.245552,914.75 L722.245552,914.75 L742.075552,899.9 L698.765552,881.62 Z",
    id: "Path",
    fill: "#FFC1C7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.035552,767.42 C407.035552,767.42 403.375552,758.81 399.035552,767.42 L396.685552,834.22 L401.845552,849.95 L407.005552,835.95 L407.035552,767.42 Z",
    id: "Path",
    fill: "#514E7F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.725552,580.34 C696.205552,582.9 687.955552,588.9 685.525552,590.78 C685.075552,590.78 683.525552,589.78 680.425548,581.05 C680.415552,581.05 699.025552,573.58 703.725552,580.34 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.855552,652.71 C622.855552,652.71 616.455552,655.82 615.385552,668.31 C614.840914,673.042634 613.611399,677.670999 611.735552,682.05 L607.525552,690.9 L607.525552,690.9 L604.175552,702.04 L604.175552,702.04 L604.525552,724.72 L595.765552,738.9 L595.035552,745.76 L592.765552,766.98 L581.125552,761.38 C581.125552,761.38 585.925552,727.16 589.525552,720.23 C593.125552,713.3 597.935552,676.6 597.935552,676.6 C597.935552,676.6 597.715552,663.13 599.445552,660.76 C601.175552,658.39 596.445552,658.82 595.995552,653.87 C595.735552,650.93 592.455552,642.77 589.825552,636.62 C593.705552,632.9 601.595552,629.09 601.595552,629.09 L609.135552,625.32 L622.855552,652.71 Z",
    id: "Path",
    fill: "#FF6584",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.855552,652.71 C622.855552,652.71 616.455552,655.82 615.385552,668.31 C614.840914,673.042634 613.611399,677.670999 611.735552,682.05 L607.525552,690.9 L607.525552,690.9 L604.175552,702.04 L604.175552,702.04 L604.525552,724.72 L595.765552,738.9 L595.035552,745.76 L592.765552,766.98 L581.125552,761.38 C581.125552,761.38 585.925552,727.16 589.525552,720.23 C593.125552,713.3 597.935552,676.6 597.935552,676.6 C597.935552,676.6 597.715552,663.13 599.445552,660.76 C601.175552,658.39 596.445552,658.82 595.995552,653.87 C595.735552,650.93 592.455552,642.77 589.825552,636.62 C593.705552,632.9 601.595552,629.09 601.595552,629.09 L609.135552,625.32 L622.855552,652.71 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.995552,603.53 C705.385552,611.39 679.545552,633.69 676.575552,648.85 C672.915552,667.54 661.925552,665.73 661.925552,665.73 C648.195552,635.95 638.745552,628.65 633.335552,627.62 L684.795552,593.06 C684.795552,593.06 684.795552,593.06 684.845552,593.06 L685.635552,592.53 L685.525552,592.53 C685.165552,592.53 684.125552,591.9 682.135552,587.22 L702.755552,581.03 C703.136719,581.334935 703.473319,581.691731 703.755552,582.09 C703.919854,582.313315 704.063765,582.550936 704.185552,582.8 C708.065552,590.8 709.785552,596.8 713.665552,601.98 C714.079342,602.521301 714.523383,603.038792 714.995552,603.53 L714.995552,603.53 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.995552,601.8 C705.385552,609.66 679.545552,631.97 676.575552,647.13 C672.915552,665.81 661.925552,664 661.925552,664 C648.195552,634.23 638.745552,626.9 633.335552,625.9 L684.795552,591.35 L684.845552,591.35 L685.635552,590.82 L685.525552,590.82 C685.165552,590.82 684.125552,590.18 682.135552,585.5 L702.755552,579.32 C703.136719,579.624935 703.473319,579.981731 703.755552,580.38 C703.922032,580.601851 704.066072,580.839684 704.185552,581.09 C708.065552,589.09 709.785552,595.09 713.665552,600.27 C714.077454,600.806494 714.521608,601.317438 714.995552,601.8 Z",
    id: "Path",
    fill: "#FF6584",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.755552,752.77 C657.395552,752.56 690.975552,733.55 687.115552,748.01 C683.255552,762.47 656.755552,752.77 656.755552,752.77 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.525552,770.98 C511.525552,770.98 529.185552,798.45 535.435552,797.59 C541.685552,796.73 511.525552,770.98 511.525552,770.98 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.525552,760.75 C533.525552,760.75 534.605552,782.08 543.875552,783.58 C553.145552,785.08 533.525552,760.75 533.525552,760.75 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.525552,829.26 C631.525552,829.26 653.465552,865.76 649.195552,878.39 L631.525552,829.26 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.965552,833.57 C656.965552,833.57 686.645552,872.57 681.505552,875.8 C676.365552,879.03 656.965552,833.57 656.965552,833.57 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.235552,770.98 C590.235552,770.98 587.185552,798.71 598.635552,806.77 L590.235552,770.98 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.335552,647.63 C723.335552,647.63 672.525552,687.06 680.665552,728 C688.805552,768.94 696.665552,771.95 696.665552,771.95 C696.665552,771.95 699.665552,788.32 705.285552,795.22 C710.905552,802.12 710.025552,806.64 710.025552,806.64 C710.025552,806.64 715.195552,804.27 716.915552,816.12 C718.635552,827.97 727.685552,836.37 727.685552,836.37 C727.685552,836.37 730.685552,845.85 722.945552,851.02 C715.205552,856.19 716.945552,861.8 716.945552,861.8 L685.485552,880.11 L720.525552,914.8 L811.025552,914.8 C811.025552,914.8 808.435552,910.28 814.025552,903.8 C819.615552,897.32 816.835552,871.7 816.835552,871.7 C816.835552,871.7 813.705552,867.6 817.535552,858.55 C821.365552,849.5 814.245552,823.65 814.245552,823.65 L806.245552,798.44 C806.245552,798.44 799.565552,780.56 800.645552,770.97 C801.725552,761.38 798.445552,750.9 798.445552,750.9 L781.075552,696.1 C781.075552,696.1 781.935552,641.38 723.335552,647.63 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.055552,647.63 C725.055552,647.63 674.205552,687.06 682.395552,728 C690.585552,768.94 698.335552,771.95 698.335552,771.95 C698.335552,771.95 701.335552,788.32 706.955552,795.22 C712.575552,802.12 711.695552,806.64 711.695552,806.64 C711.695552,806.64 716.865552,804.27 718.595552,816.12 C720.325552,827.97 729.365552,836.37 729.365552,836.37 C729.365552,836.37 732.365552,845.85 724.625552,851.02 C716.885552,856.19 718.625552,861.8 718.625552,861.8 L687.165552,880.11 L722.285552,914.8 L812.775552,914.8 C812.775552,914.8 810.195552,910.28 815.775552,903.8 C821.355552,897.32 818.575552,871.7 818.575552,871.7 C818.575552,871.7 815.445552,867.6 819.275552,858.55 C823.105552,849.5 815.985552,823.65 815.985552,823.65 L807.985552,798.44 C807.985552,798.44 801.305552,780.56 802.385552,770.97 C803.465552,761.38 800.165552,750.9 800.165552,750.9 L782.795552,696.1 C782.795552,696.1 783.655552,641.38 725.055552,647.63 Z",
    id: "Path",
    fill: "#FF6584",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.075552,675.42 C742.075552,675.42 778.275552,687.7 787.965552,693.74 C797.655552,699.78 773.745552,669.82 742.075552,675.42 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.035552,861.8 C761.035552,861.8 812.525552,868.26 809.525552,878.39 C806.525552,888.52 761.035552,861.8 761.035552,861.8 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.945552,872.78 C750.945552,872.78 788.615552,884.85 781.945552,894.78 C775.275552,904.71 750.945552,872.78 750.945552,872.78 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.615552,632.09 C731.065552,636.09 710.415552,639.51 689.755552,642.92 L684.375552,643.81 C673.015552,645.68 661.585552,647.56 650.065552,647.501399 C644.455552,647.501399 638.675552,646.92 633.695552,644.32 C632.631135,643.75542 631.626094,643.085393 630.695552,642.32 C627.205552,639.52 624.695552,635.45 624.755552,631.03 C624.815552,622.97 632.465552,617.38 639.045552,612.72 C648.675552,605.89 658.185552,597.22 661.905552,586.33 C662.613875,584.288208 663.100017,582.176005 663.355552,580.03 C664.455552,570.78 661.085552,561.65 657.495552,553.03 C653.575552,543.68 648.195552,533.63 640.335552,527.95 C637.154862,525.611362 633.437895,524.108759 629.525552,523.58 C617.445552,521.98 606.015552,530.58 593.845552,530.1 C583.955552,529.67 575.555552,523.32 569.605552,515.85 C565.275552,510.41 562.535552,503.13 556.015552,499.9 C548.955552,496.39 540.925552,495.56 533.075552,494.39 C541.821461,460.018959 571.01111,434.705997 606.274022,430.913046 C641.536933,427.120095 675.44203,445.646457 691.297351,477.371339 C707.152673,509.096222 701.616972,547.334131 677.415552,573.26 C677.545552,573.69 677.685552,574.12 677.835552,574.54 C678.576298,576.752605 679.430768,578.925496 680.395552,581.05 C680.395552,581.05 696.855552,574.44 702.725552,579.28 C703.106719,579.584935 703.443319,579.941731 703.725552,580.34 C703.892032,580.561851 704.036072,580.799684 704.155552,581.05 C708.035552,589.05 709.755552,595.05 713.635552,600.23 C714.055829,600.781079 714.510042,601.305429 714.995552,601.8 C719.685552,606.71 728.995552,612.46 727.425552,614.02 C725.705552,615.74 740.355552,623.02 740.355552,623.02 C740.355552,623.02 748.925552,627.97 751.615552,632.09 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.675552,479.09 C501.015552,469.21 501.845552,455.25 504.675552,443.09 C506.455552,435.42 508.985552,427.71 513.945552,421.6 C518.905552,415.49 526.715552,411.21 534.525552,412.27 C539.095552,412.89 543.225552,415.22 547.525552,416.92 C566.825552,424.56 590.765552,418.21 603.745552,402 C606.685552,398.33 609.115552,394.21 612.595552,391 C616.492906,387.638954 621.156199,385.286703 626.175552,384.15 C647.895552,378.67 670.295552,389.46 688.875552,401.97 C704.735552,412.65 719.815552,425.12 730.225552,441.15 C739.685253,455.796387 744.879276,472.787769 745.225552,490.22 C745.755552,517.82 734.115552,545.66 740.775552,572.44 C747.345552,598.89 773.175552,619.25 800.425552,619.44 C763.005552,628.62 724.945552,634.91 686.935552,641.18 C675.565552,643.06 664.145552,644.94 652.625552,644.871896 C647.015552,644.871896 641.225552,644.29 636.255552,641.69 C631.285552,639.09 627.255552,634.04 627.255552,628.43 C627.315552,620.36 634.975552,614.78 641.545552,610.12 C652.965552,602.02 664.215552,591.33 665.865552,577.43 C666.965552,568.18 663.595552,559.04 659.995552,550.43 C654.505552,537.33 646.135552,522.82 632.055552,520.94 C619.985552,519.33 608.545552,527.94 596.375552,527.45 C586.495552,527.02 578.085552,520.67 572.135552,513.2 C567.805552,507.76 565.065552,500.48 558.555552,497.25 C542.465552,489.29 521.235552,495.28 508.675552,479.09 Z",
    id: "Path",
    fill: "#945B79",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.755552,428.75 C745.07774,417.421462 749.750228,395.338914 739.415552,378.37 C739.875552,378.95 740.315552,379.55 740.745552,380.16 C748.644684,391.177667 749.993651,405.597051 744.275157,417.888679 C738.556664,430.180307 726.658214,438.436531 713.142566,439.491297 C699.626918,440.546063 686.591685,434.235671 679.035552,422.98 C678.615552,422.36 678.205552,421.73 677.825552,421.1 C690.103711,436.72436 712.429018,440.077758 728.755552,428.75 Z",
    id: "Path",
    fill: "#945B79",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.1,
    transform: "translate(502.005552, 385.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.76,13.37 C110.7,9.69 113.13,5.57 116.61,2.37 C117.181044,1.84960627 117.778502,1.35895689 118.4,0.9 C115.536635,2.08694408 112.893142,3.74673287 110.58,5.81 C107.1,8.99 104.67,13.11 101.73,16.81 C98.7449431,20.510724 95.206632,23.728597 91.24,26.35 C97.6471957,23.311797 103.292157,18.8764702 107.76,13.37 L107.76,13.37 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.99,252.61 C179.63,254.48 168.2,256.36 156.68,256.29 C151.07,256.29 145.29,255.72 140.31,253.12 C135.33,250.52 131.31,245.47 131.36,239.85 C131.42,231.79 139.07,226.21 145.65,221.54 C157.07,213.44 168.31,202.75 169.96,188.85 C171.06,179.61 167.69,170.46 164.09,161.85 C158.6,148.75 150.24,134.23 136.15,132.36 C124.08,130.75 112.65,139.36 100.48,138.86 C90.6,138.44 82.19,132.09 76.24,124.62 C71.9,119.18 69.16,111.9 62.65,108.67 C46.49,100.67 25.26,106.67 12.65,90.45 C4.99,80.57 5.83,66.6 8.65,54.45 C10.43,46.78 12.96,39.07 17.91,32.95 C19.2985464,31.2467229 20.8827825,29.7128334 22.63,28.38 C18.427916,30.0948849 14.7293152,32.847332 11.88,36.38 C6.88,42.49 4.39,50.21 2.61,57.87 C-0.22,70.05 -1.05,84.02 6.61,93.87 C19.17,110.06 40.4,104.07 56.61,112.09 C63.12,115.33 65.86,122.61 70.19,128.09 C76.19,135.55 84.55,141.91 94.43,142.33 C106.6,142.85 118.04,134.21 130.11,135.82 C144.19,137.7 152.56,152.21 158.05,165.32 C161.65,173.9 165.05,183.04 163.92,192.32 C162.27,206.22 151.02,216.91 139.6,225.01 C133.03,229.67 125.37,235.26 125.31,243.32 C125.31,248.93 129.31,253.99 134.31,256.59 C139.31,259.19 145.07,259.73 150.68,259.761896 C162.2,259.83 173.68,257.95 184.99,256.07 C222.99,249.8 261.06,243.52 298.48,234.33 C296.266198,234.307217 294.055678,234.153615 291.86,233.87 C258.52,241.46 224.73,247.04 190.99,252.61 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFC1C7",
    fillRule: "nonzero",
    cx: 410.725552,
    cy: 818.48,
    rx: 16.4,
    ry: 8.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.705552,152.12 C663.455552,147.25 645.025552,142.36 626.145552,141.58 C607.265552,140.8 587.655552,144.46 572.245552,155.38 C564.535552,160.84 558.135552,167.91 551.645552,174.79 C517.18882,211.308328 478.726074,243.826892 436.985552,271.73 C420.175552,282.96 402.205552,293.67 382.175552,296.46 C362.145552,299.25 339.515552,292.31 329.175552,274.95 L335.335552,271.79",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.75,
    opacity: 0.3,
    strokeDasharray: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.815552,125.84 L713.585552,125.84 C708.487964,125.84 704.35553,121.707588 704.35553,116.61 L704.35553,98.15 C704.35024,95.6985884 705.320338,93.3457605 707.051875,91.6104716 C708.783412,89.8751828 711.134135,88.9 713.585552,88.9 L842.815552,88.9 C847.91314,88.9 852.045552,93.0324118 852.045552,98.13 L852.045552,116.61 C852.045552,121.707588 847.91314,125.84 842.815552,125.84 L842.815552,125.84 Z M828.965552,100.459993 C825.145048,100.465521 822.051876,103.566151 822.055552,107.386657 C822.059235,111.207163 825.158373,114.30183 828.978881,114.299993 C832.799388,114.298154 835.895552,111.200508 835.895552,107.38 C835.895552,105.542968 835.165112,103.781322 833.865197,102.483282 C832.565281,101.185243 830.802582,100.457345 828.965552,100.459993 L828.965552,100.459993 Z M810.505552,100.46 C806.683742,100.46 803.585552,103.55819 803.585552,107.38 C803.585552,111.20181 806.683742,114.3 810.505552,114.3 C814.327363,114.3 817.425552,111.20181 817.425552,107.38 C817.425552,103.565986 814.33955,100.471023 810.525552,100.46 L810.505552,100.46 Z M842.815552,172 L713.585552,172 C708.486347,171.994481 704.355552,167.859208 704.355552,162.76 L704.355552,144.3 C704.355552,139.202412 708.487964,135.07 713.585552,135.07 L842.815552,135.07 C847.91314,135.07 852.045552,139.202412 852.045552,144.3 L852.045552,162.76 C852.045552,167.859208 847.914758,171.994481 842.815552,172 L842.815552,172 Z M828.965552,146.609993 C826.161719,146.609993 823.63416,148.299527 822.562116,150.890319 C821.490072,153.48111 822.084809,156.46261 824.068849,158.443787 C826.052889,160.424964 829.035244,161.015394 831.624485,159.939611 C834.213725,158.863827 835.899598,156.33383 835.895559,153.53 C835.895559,151.692968 835.165112,149.931322 833.865197,148.633282 C832.565281,147.335243 830.802582,146.607345 828.965552,146.609993 L828.965552,146.609993 Z M810.505552,146.609993 C807.700813,146.605956 805.170184,148.292912 804.094988,150.883381 C803.019792,153.473851 803.612057,156.456991 805.595309,158.440243 C807.578562,160.423495 810.561702,161.015761 813.152171,159.940564 C815.74264,158.865368 817.429596,156.334739 817.425559,153.53 C817.425559,149.715986 814.33955,146.621023 810.525552,146.609993 L810.505552,146.609993 Z M842.815552,218.15 L713.585552,218.15 C708.487964,218.15 704.355552,214.017588 704.355552,208.92 L704.355552,190.46 C704.355552,185.362412 708.487964,181.23 713.585552,181.23 L842.815552,181.23 C847.91314,181.23 852.045574,185.362412 852.045574,190.46 L852.045574,208.9 C852.050864,211.351412 851.080766,213.70424 849.349229,215.439528 C847.617692,217.174817 845.266969,218.15 842.815552,218.15 L842.815552,218.15 Z M828.965552,192.759993 C826.162629,192.759993 823.635699,194.44844 822.563067,197.038004 C821.490435,199.627567 822.083336,202.608284 824.065302,204.59025 C826.047268,206.572216 829.027985,207.165117 831.617548,206.092485 C834.207112,205.019853 835.895559,202.492923 835.895559,199.69 C835.898211,197.851236 835.168942,196.087018 833.868738,194.786814 C832.568534,193.48661 830.804316,192.757341 828.965552,192.759993 L828.965552,192.759993 Z M810.505552,192.759993 C807.701722,192.755954 805.171725,194.441827 804.095942,197.031067 C803.020158,199.620308 803.610588,202.602663 805.591765,204.586703 C807.572942,206.570744 810.554442,207.16548 813.145233,206.093436 C815.736025,205.021393 817.42556,202.493833 817.42556,199.69 C817.431085,195.872084 814.343456,192.77103 810.525552,192.759993 L810.505552,192.759993 Z",
    id: "Shape",
    fill: "#514E7F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.735552,150.55 C872.025552,149.66 880.895552,149.91 888.005552,154.28 C895.535552,158.91 899.885552,167.55 901.345552,176.28 C902.805552,185.01 901.785552,193.93 900.745552,202.71 L895.145552,250.07 C894.355552,256.7 893.595552,263.6 895.745552,269.93 C897.895552,276.26 903.845552,281.82 910.495552,281.23",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.75,
    opacity: 0.3,
    strokeDasharray: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.095552,552.6 C343.445552,553.13 367.515552,552.6 382.265552,537.16 C393.465552,525.44 396.095552,508.27 399.865552,492.5 C406.675552,464.03 419.055552,436.63 437.865552,414.18 C456.675552,391.73 482.065552,374.43 510.485552,367.45 C533.325552,361.83 557.345552,362.89 580.305552,357.84 C603.265552,352.79 626.845552,339.18 633.195552,316.54",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.75,
    opacity: 0.3,
    strokeDasharray: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.005552,266.95 L622.395552,287.95 C621.998951,288.100754 621.720221,288.460968 621.673829,288.88271 C621.627437,289.304453 621.821204,289.716642 622.175552,289.95 L630.775552,294.72 C631.265401,295.00664 631.624151,295.473016 631.775552,296.02 L636.705552,311.62 C636.705552,312.28 637.905552,312.62 638.015552,311.98 L638.705552,299.78 C638.903813,298.898438 639.368085,298.099053 640.035552,297.49 L671.695552,274.49 C671.881258,274.365668 672.114665,274.336029 672.325552,274.41 C672.528236,274.491416 672.675403,274.670579 672.7159,274.885217 C672.756398,275.099855 672.684634,275.320326 672.525552,275.47 L644.375552,301.14 C643.767752,301.776913 643.324894,302.552773 643.085552,303.4 L640.085552,313.59 C640.085552,314.51 640.725552,314.96 641.425552,314.23 L647.425552,308.96 C647.630303,308.752971 647.909375,308.636469 648.200552,308.636469 C648.491729,308.636469 648.770802,308.752971 648.975552,308.96 L660.795552,320.56 C661.058709,320.821059 661.437362,320.92892 661.798583,320.845718 C662.159804,320.762515 662.453117,320.499876 662.575552,320.15 L681.285552,268.43 C681.444355,268.031888 681.355099,267.577662 681.057462,267.269241 C680.759825,266.96082 680.309062,266.855461 679.905552,267 L680.005552,266.95 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero",
    opacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractionDesign);
export default __webpack_public_path__ + "static/media/interaction_design.37de8629ce884b33abf01b60561ac1d0.svg";
export { ForwardRef as ReactComponent };